export const KG = {
  RESTORE: {
    TITLE: 'Жеткиликтүүлүктү калыбына келтирүү',
    IIN_SUBTITLE: 'Интернет-банкингде каттоодо көрсөтүлгөн СТИН жазыңыз',
    PHONE_SUBTITLE: 'Интернет-банкингде каттоодо көрсөтүлгөн телефон номерди жазыңыз',
  },
  AUTH: {
    LOGIN_TITLE: 'Кирүү',
    LOGIN_SUBTITLE: 'бизнес үчүн интернет-банкингге',
    REGISTER: 'Катталуу',
    LOGIN: 'Кирүү',
    SET_PASSWORD: 'Сырсөздү коюу',
    LOGIN_OB_BROWSER: 'браузер аркылуу Optima Businessке кирүү үчүн',
    UNEXPECTED_ERROR: 'Системанын күтүүсүз катасы. Сураныч, бир аздан кийин аракет кылып көрүңүз.',
    NOT_FOUND_COMPANY: 'Компаниялар жөнүндө маалымат жок',
    CHECK: {
      CAPSLOCK: 'Caps Lock басылган',
      LANGUAGE: 'Кирүү тилин текшериңиз',
      CAPSLOCK_AND_LANGUAGE: 'Кирүү тилин жана Сaps Lockту текшериңиз',
    },
    PASSWORD: {
      TITLE: 'Сырсөз',
    },
    INVALID: 'Кардардын IDси же сырсөз туура эмес',
    ENTER_ID: 'Кардардын IDсин жазыңыз',
    ENTER_PASSWORD: 'Сырсөздү жазыңыз',
    CODE: {
      SEND_NEW: 'Жаңы кодду алуу',
    },
    TOTP_CODE: {
      ERROR: 'TOTP-код туура эмес. Сураныч, бир аздан кийин аракет кылып көрүңүз.',
    },
    LOCK: {
      DATA_VERIFICATION: 'Маалыматтарыңызды текшергиче күтө туруңуз',
      DATA_VERIFICATION_LABEL: 'Эгер баары туура болсо, бул бөлүм текшерүүдөн кийин жеткиликтүү болот',
    },
  },
  PERSONAL_QR: {
    TITLE: 'Жеке QR',
    SOON: {
      TITLE: 'Жакында бул жерде персоналдык QR-код ПАЙДА! болот',
      TEXT: 'Кардардын төлөм багытын көрсөтүү менен-эмне үчүн, ким үчүн жана кандай сумма үчүн QR-коддорду түзө аласыз',
    },
  },
  RESET_PASSWORD: {
    TITLE: 'Сырсөздү өчүрүү',
    SUB_TITLE: 'Optima Businessке кирүү үчүн',
    PHONE: 'Телефон номериңизди жазыңыз',
    FINISH: {
      TITLE: 'Сырсөзүңүз жокко чыкты!',
      SUB_TITLE: 'Системага кирүү жана жаңы сырсөздү орнотуу үчүн телефон номериңизге бир жолку сырсөз жиберилди',
    },
    SMS_CODE: {
      CONFIRMATION: 'SMS тастыктоо',
      ENTER: 'Каттоодо көрсөтүлгөн телефон номериңизге жиберелген SMSтеги кодду жазыңыз',
      GET_NEW: 'Жаңы кодду {countdown} сек кийин алууга болот',
      OUTDATED: 'SMS-код эскирди',
      REQUEST: 'Каттоодо көрсөтүлгөн телефон номерине жаңы код жиберүүнү сураныңыз',
    },
  },
  HELP: {
    TITLE: 'Жардам',
    CONTACTS: 'Контакттар',
    CALL_CENTRE: 'Колдоо кызматы',
    CALL_NUMBER: 'Номерине чалуу',
    CHAT_SUPPORT: 'Колдоо чаты',
    WRITE_WHATSAPP: 'WhatsApp',
    USER_MANUAL: 'Авторизация боюнча колдонмо',
  },
  SESSION: {
    CONTINUE: 'Сеансты уланталыбы?',
    EXPIRE: 'Кийин сиздин сеансыңыз аяктайт',
  },
  DIRECTORY: {
    DICTIONARY: 'Маалымдама',
  },
  INFORMATION: {
    PHONE: 'Телефон номери',
    PHONES: 'Телефон номерлери',
    PARTY_ID: 'Кардардын IDси',
  },
  CITY: 'Бишкек',
  DIALOG: {
    TO_MAIN: 'Башкы бетке',
    RETURN: 'Кайтуу',
    TRY_AGAIN: 'Дагы бир жолу аракет кылуу',
    RETURN_HISTORY: 'Тарыхка кайтуу',
    TO_PAYMENT_CREATE: 'Операцияларды түзүүгө',
    SAVE_TEMPLATES: 'Үлгүгө сактоо',
    EXIT: 'Чыгуу',
    CANCEL: 'Жокко чыгаруу',
  },
  SHARED: {
    SOON: {
      TITLE: 'Жакында болот',
      SUB_TITLE: 'Сураныч, күтө туруңуз',
    },
    NOT_ENOUGH_CHARACTERS: 'Символдор жетишсиз',
    COMMISSION: 'Комиссиясы',
    TOTAL: 'Бардыгы',
    AMOUNT_FROM: 'Суммадан баштап',
    MOUNT_TO: 'Суммага чейин',
    DATE_FROM: 'Күндөн баштап',
    DATE_TO: 'Күнгө чейин',
    TIME_FROM: 'Убакыттан баштап',
    TIME_TO: 'Убакытка чейин',
    TIME: 'Убакыт',
    ALL: 'Баары',
    COMMISSION_BANK: 'Банктын комиссиясы',
    CREATED_DATE: 'Түзүлгөн күнү',
    INTERFACE_LANG: 'Интерфейс тили',
    DATETIME: 'Дата жана убакыт',
    OPERATION_HISTORY: 'Операциялар тарыхы',
    OPERATIONS: 'Операциялар',
    NO_DATA: 'маалымат жок',
    ACTION: {
      CHOOSE: 'Тандоо',
      ACCEPT: 'Кабыл алуу',
      RETURN: 'Кайтуу',
      EDIT: 'Редакциялоо',
      CHANGE: 'Өзгөртүү',
      OK: 'Ок',
      YES: 'Ооба',
      NO: 'Жок',
      ICON_PDF: 'PDFти жүктөө',
      CONFIRM: 'Тастыктоо',
      CREATE: 'Түзүү',
      RECREATE: 'Кайрадан түзүү',
      IMPORT: 'Импорт',
      CLOSE: 'Жабуу',
      APPLY: 'Колдонуу',
      RESET: 'Жокко чыгаруу',
      RETRY: 'Жаңылоо',
      ACCESSIBLY: 'Түшүнүктүү',
      CONTINUE: 'Улантуу',
      CANCEL: 'Жокко чыгаруу',
      EXIT: 'Чыгуу',
      OPEN: 'Ачык',
      FORGOT_PASSWORD: 'Сырсөздү унуттуңузбу?',
      CANCELED: 'Жокко чыгаруу',
      ADD: 'Кошуу',
      LOOK: 'Кароо',
      DOWNLOAD: 'Жүктөө',
      BACK: 'Артка',
      DELETE: 'Өчүрүү',
      REPEAT: 'Кайталоо',
      REVOKE: 'Четке кагуу',
      SIGN: 'Кол коюу',
      FOR_SIGN: 'Кол коюуга',
      SAVED: 'Сактоо',
      NEXT: 'Кийинки',
      DONE: 'Даяр',
      SWITCH: {
        ON: 'Күйгүзүү',
        OFF: 'Өчүрүү',
      },
      CHOOSE_TEMPLATE: 'Шаблондордон тандоо',
      WRITE_OFF: 'Эсептен алуу',
      SAVE_TEMPLATE: 'Үлгүнү сактоо',
      ENROLL: 'Эсепке кошуу',
      RELOAD: 'Кайра жүктөө',
      GOOD: 'Макул',
      COPY: 'Маалыматтар көчүрүлдү',
      COPY_ACTION: 'Көчүрүү',
      PAYMENTS: 'Төлөмдөр',
    },
    COMMENT: 'Комментарий',
    OUTGOING: 'Жөнөтүлгөн',
    INCOMING: 'Кирген',
    REQUISITE: 'Реквизит',
    RECEIPT_NUMBER: 'Жөнөтүүчүнүн квитанция номери',
    SENDER_ACCOUNT: 'Жөнөтүүчүнүн эсеби',
    AMOUNT_AFTER_COMMISSION: 'Комиссиядан менен суммасы',
    ABOUT_PAYMENT: 'Төлөм тууралуу',
    FOUND: 'Табылды',
    ENROLLMENT_ACCOUNT: 'Эсепке которуу счету',
    CHANGES_SAVED: 'Өзгөртүүлөр сакталды',
    READY: 'Даяр!',
    AGREE_FOR_CONTINUE: 'Улантуу үчүн төмөнкү маалыматты ырастаңыз',
    SORTING: 'Сортоо',
    FULL_NAME: 'ФАА',
    CREATED: 'Tүзүлгөн',
    ADDRESS: 'Дареги',
    CITY: 'Шаар',
    ACTUAL_ADDRESS: 'Иш жүзүндө жашаган дареги',
    PCS: 'шт',
    MAIN: 'Негизги',
    PHOTO: 'Фото',
    BACK: 'Артка',
    ACCOUNT_NUMBER: 'Эсеп номери',
    DOWNLOAD: 'Жүктөө',
    DEPOSITS: 'Депозиттер',
    INFORMATION: 'Маалымат',
    GENERAL: 'Жалпы',
    SECURITY: 'Коопсуздук',
    USER_ACCOUNT: 'Аккаунт',
    STATUS: 'Статус',
    NUMBER: 'Номер',
    NUMBER_SYMBOL: '№',
    TYPE: 'Тип',
    EXIT: 'Чыгуу',
    CREATE: 'Түзүү',
    PRODUCTS: 'Өнүмдөр',
    LOOK: 'Көрүү',
    SEE_ALL: 'Баарын көрүү',
    IMPORT: 'Импорт',
    RETRY: 'Жаңылоо',
    CONTINUE: 'Улантуу',
    CANCEL: 'Жокко чыгаруу',
    CANCELED: 'Жокко чыгаруу',
    CONFIRM: 'Тастыктоо',
    PHONE: 'Телефон',
    INN: 'СТИН',
    REGION: 'Район',
    AIYL_AREA: 'Айылдык аймак',
    KBK: 'Бюджеттик классификациянын коду',
    PASSWORD: 'Сырсөз',
    ACCOUNT_PASSWORD: 'Аккаунттун сырсөзү',
    DONE: 'Даяр',
    FORGOT_PASSWORD: 'Сырсөздү унуттуңузбу?',
    CONTRACT: 'Келишим',
    REMAINDER: 'Калдык',
    YES: 'Ооба',
    NO: 'Жок',
    OK: 'Ок',
    CURRENCY: 'Валюта',
    DOCUMENT_NUMBER: 'Документ номери',
    SUM: 'Сумма',
    RATE: 'Курс',
    FILTER: {
      TITLE: 'Фильтр',
      SEARCH: 'Издөө',
      APPLY: 'Колдонуу',
      RESET: 'Жокко чыгаруу',
    },
    TOTP: {
      CODE: 'TOTP-коду',
      ENTER_CODE: 'Түзүлгөн TOTP-кодду жазыңыз',
      INVALID_TOTP: 'TOTP-код туура эмес. Сураныч, бир аздан кийин аракет кылып көрүңүз.',
    },
    SWITCH: {
      ON: 'Күйгүзүү',
      OFF: 'Өчүрүү',
    },
    SAVE: {
      SAVED: 'Сактоо',
      SUCCESSFUL: 'Ийгиликтүү сакталды',
      CHANGES: 'Өзгөртүүлөрдү сактоо',
    },
    SMS: {
      TITLE: 'SMS',
    },
    SIGN_TYPE: {
      ONE_SIGNATORY: 'Бир кол коюучу',
      TWO_SIGNATORY: 'Эки кол коюучу',
    },
    SIGN_RIGHT: {
      AUDITOR: 'Аудитор',
      CREATOR: 'Аткаруучу',
      FIRST: '1-колтамга',
      SECOND: '2-колтамга',
      THIRD: '3-колтамга',
      NONE: 'Колу жок',
      CASH_MANAGER: 'Менеджер',
      CASHIER: 'Кассир',
    },
    ERROR_PLACEHOLDER: {
      SUBTITLE: 'Баракчаны жаңылап көрүңүз',
      TITLE: 'Сервердин катасы',
    },
    SYSTEM_ERROR: 'Системанын күтүлбөгөн катасы. Кийинчерээк кайталап көрүңүз',
    ACCOUNT: {
      TITLE: 'Менин өнүмдөрүм',
      RKO: 'Эсеп',
      CARD: 'Карта',
      DEPOSIT: 'Депозит',
      SETTLEMENT_ACCOUNTS: 'Эсептер',
      CARDS: 'Карталар',
    },
    RULE: {
      FILL_FIELD: 'Боштукту толтуруңуз!',
      FILL_LATIN: 'Боштукту латын арибинде толтуруңуз!',
      NEW_OLD_PASSWORD_REPEATED: 'Жаңы сырсөз учурдагыдан айырмаланышы керек.',
      CONVERSION_AMOUNT_EXCEEDS_BALANCE: 'Конвертация суммасы эсептин жеткиликтүү балансынан ашат',
      PAYMENT_AMOUNT_EXCEEDS_BALANCE: 'Төлөм суммасы жеткиликтүү эсеп балансынан ашык',
      ACCOUNT_INSUFFICIENT_FUNDS: 'Эсепте каражат жетишсиз',
      INCORRECT_DATE: 'Туура эмес дата',
      INCORRECT_TIME: 'Туура эмес саат',
      INCORRECT_SYMBOLS: 'Жарабай турган символдор {value}',
      INCORRECT_MANUAL_RATE: 'Туура эмес келишим курсу',
      INCORRECT_PERCENTAGE_DIFFERENCE: 'Жарабай турган маани!',
      NO_ACCESS_OPERATION: 'Операция жеткиликтүү эмес!',
      FORBIDDEN_SEND_EXTERNAL_ACCOUNT: 'Сырткы эсептерге жиберүүгө тыюу салынат',
      SAME_DEBIT_ACCOUNT: 'Чыгаруу эсебине дал келет',
      TIME_EXPIRED: 'Убакыт чектелген. Операция жеткиликтүү эмес.',
      PAY_CONTROL_NOT_EXIST:
        'Мобилдик тиркемеде Rutoken же TOTP менен кол коюуга болбойт. Сураныч, операцияга сайттан кол коюуңуз',
      PAY_CONTROL_NOT_AVAILABLE: 'Төлөмду кол коюуга жиберүү мүмкүн эмес. Кол коюучулардын биринде PayControl жок.',
      INCORRECT_INN: 'Туура эмес СТИН',
      INCORRECT_DATA: 'Туура эмес маалымат',
      INCORRECT_PASSWORD: 'Туура эмес сырсөз',
      ONE_YEAR_PERIOD: 'Сиз болгону 1 жылдык мөөнөттү тандай аласыз',
      MONTH_PERIOD: 'Сиз болгону 31 күндүү мөөнөттү тандай аласыз',
      MAX_LENGTH: 'Символдорду киргизүү үчүн максималдык узундук {length}',
      MIN_LENGTH: 'Символдорду киргизүү үчүн минималдуу узундук {length}',
      CLIENT_NOT_FOUND: 'Кардар табылган жок. Киргизилген маалыматтардын тууралыгын текшериңиз',
      IBAN: 'Эсептин түзүлүшү IBAN стандартына туура келбейт',
      OUTLET_CHECK: 'Тамга, сан, боштук жана сызыкча гана колдонулушу керек',
      NOT_EMOJI: 'Эмодзи туура келбейт',
    },
    SEARCH: 'Издөө',
    TIME_LIMIT: 'Төлөмдү саат {timeFrom} дөн {timeTo} ге чейин түзсө болот',
    VALUE_DATE: 'Валюталоо датасы',
    AMOUNT_PAYMENT: 'Төлөм суммасы',
    ACCOUNT_NOT_FOUND: 'Эсеп табылган жок!',
    CHOOSE_TEMPLATE: 'Шаблондордон тандоо',
    NAME_LEGAL_ENTITY: 'Төлөөчүнүн аты',
    WITHDRAWAL_ACCOUNT: 'Чыгаруу эсеби',
    RECIPIENT: 'Алуучу',
    RECIPIENT_NAME: 'Алуучунун аты',
    APPOINTMENT: 'Максатына карай',
    TYPE_TRANSACTION: 'Операциянын түрү',
    ENROLL: 'Эсептен алуу',
    WRITE_OFF: 'Эсептен алуу',
    PAYMENT_CODE: 'Төлөм коду',
    SAVE_TEMPLATE: 'Шаблонду сактоо',
    NAME: 'Аталышы',
    PAYMENT_DETAILS: 'Төлөм деталдары',
    OPERATION_DETAILS: 'Операция деталдары',
    INVOICE_COMMISSION_PAYMENT: 'Комиссия төлөө үчүн эсеп',
    PAYER: 'Төлөөчү',
    CLOSE: 'Жабуу',
    BIN: 'БИН',
    KPP: 'КПП',
    BIC_SWIFT: 'БИК/SWIFT',
    BIC_SWIFT_INTERMEDIARY: 'Ортомчу банктын БИК/SWIFTи',
    NOT_FOUND: 'Маалымат табылган жок',
    MORE: 'көбүрөөк',
    LESS: 'азыраак',
    DETAILED_INFO_BY_CALL_CENTER: 'Кененирээк маалыматты 9500 номери боюнча банктын колдоо борборунан алсаңыздар болот',
    WEEK: {
      MON: 'ДШ',
      TUE: 'ШШ',
      WED: 'ШР',
      THU: 'БШ',
      FRI: 'ЖМ',
      SAT: 'ИШ',
      SUN: 'ЖК',
    },
    CONFIRM_CLOSE_TITLE: 'Чыккыңыз келеби?',
    CONFIRM_EXIT_TITLE: 'Чын эле чыгууну каалайсызбы?',
    NOT_HAVE_PRODUCTS: 'Азырынча сизде Optima Businessте өнүмдөрүңүз жок',
  },
  CALCULATOR: {
    CURRENCY_CONVERTOR: 'Валюта калькулятору',
    TYPE_RATE: 'Курстардын түрү',
  },
  FORM_PAYMENT: {
    NOT_ENOUGH_MONEY: 'Эсепте каражат жетишсиз',
    NOT_ENOUGH_MONEY_DESCRIPTION:
      'Пландалган калдык: {plannedBalance} {currency}.\nБашка сумманы киргизиңиз же эсепти толуктаңыз.',
    NOT_ENOUGH_MONEY_BUTTON: 'Мен башка сумманы киргизем',
    INSUFFICIENT_FUNDS_DIALOG: {
      SINGLE_PAYMENT_TITLE: 'Төлөмдү кол коюуга жөнөтүү үчүн каражат жетишсиз',
      PAYMENT_AMOUNT: 'Төлөм суммасы:',
      AVAILABLE_BALANCE: 'Жеткиликтүү калдык:',
      DESCRIPTION: 'Төлөмдү өзгөртүп же кол коюуга жөнөтүүнү уланта аласыз',
      EDIT: 'Түзөтүү',
      CONTINUE: 'Улантуу',
    },
    PAYMENTS_FOR_SIGNATURE: 'Кол коюуга төлөмдөр',
    CONVERSION: {
      PURCHASE: 'Сатып алуунун орнотулган курсу',
      CONTRACTUAL_PURCHASE: 'Сатып алуунун макулдашылган курсу',
      SALES: 'Сатуунун орнотулган курсу',
      CONTRACTUAL_SALES: 'Сатуунун макулдашылган курсу',
      CONVERSION: 'Конвертациянын орнотулган курсу',
      CONTRACTUAL_CONVERSION: 'Конвертациянын макулдашылган курсу',
      ENROLLMENT_ACCOUNT: 'Эсепке которуу счету',
      DIDNT_LOAD: 'Курс жүктөлгөн жок.<br/>Сураныч, конвертациянын курсун жаңылагыла',
      RESET_VALUE_RATE: 'Бекитилгенге кайтуу',
      TEXT_INFO_CONVERSION: 'Эгер сумма 10 000 USD ашса, анда курсту келишим түрдө орнотсо болот',
    },
    TRANSFER: {
      PAYMENT_CODE: {
        LABEL: 'Төлөм коду',
        HINT: 'Максатына карай ылайык кодду тандаңыз. Издөө код жана аталышы боюнча жүргүзүлөт',
      },
      PAYING_GOODS_SERVICES:
        'Товарлар/кызматтар үчүн төлөөдө товарлардын, жумуштардын, кызматтардын аталышын, келишимдердин/эсептердин номерлерин жана даталарын көрсөтүңүз',
      BIC_BANK_NAME: 'БИК/Банктын аталышы',
      NAME_RECIPIENT: 'Алуучунун аты',
      NOT_OPERATION_TYPE: 'Операциянын түрүн тандаңыз',
      AVAILABLE_UNTIL: '{timeFrom} дөн {timeTo} ге чейин жеткиликтүү',
      MAX_AMOUNT_ONE_MILLION: ' Максималдык сумма 1 млн сомго чейин',
      FORBIDDEN_SYMBOL: '& тыюу салынган белги болуп саналат.',
      INTRABANK_RKO_TO_CARD_NOT_ALLOWED: 'Эсеп карталык эсеп болуп саналат. Сураныч, учурдагы эсепти киргизиңиз.',
      ACCOUNT_NOT_EXIST_FOR_OPERATION:
        'Тандалган чыгаруу эсеби үчүн "{operation}" операциясынын бул тиби жеткиликтүү эмес. Мүмкүнчүлүк алуу үчүн биринчи кол коюучуга кайрылыңыз.',
    },
    SWIFT: {
      COUNTRY: 'Өлкө',
      CORRESPONDENT_ACCOUNT: 'Корреспонденттик эсеп',
      NAME: 'Аталышы',
      ACCOUNT_IBAN: 'Эсеп/IBAN',
      CURRENCY_TRANSACTION_CODE: 'Валюттук операцияларды VO коду',
      INTERMEDIARY_BANK: 'Ортомчу банк',
      EXOTIC_CURRENCY: 'Экзотикалык валюта',
      AVAILABLE_DEBIT_ACCOUNT_IS_EURO: 'Чыгаруу эсебинин валютасы евро болсо, жеткиликтүү',
      CROSS_RATE: 'Кросс-курс',
      PAYMENT_CODE: {
        LABEL: 'Төлөм коду',
        HINT: 'Максатына карай ылайык кодду тандаңыз. Издөө код жана аталышы боюнча жүргүзүлөт',
      },
      CARGO:
        '"Оптима Банк" ААКсына товар жеткирилгенден кийин 3 (үч) жумушчу күндүн ичинде (товарларды которуулар үчүн) бул которуу боюнча Кыргыз Республикасынын аймагына товар жеткирилгендигин тастыктаган расмий документти берүүгө милдеттенем',
      TRANSFER_BETWEEN_BANKS: 'КР банктары ортосунда которууларда ортомчу банк  милдеттүү түрдө көрсөтүлөт',
      RUS_USD_EUR_NOT_ALLOWED:
        'АКШ долларында (USD) жана евро (EUR) валютасында Россия Федерациясына акча которуулар убактылуу жеткиликсиз',
      RUS_USD_EUR_WARNING:
        'Урматтуу кардарлар! Россия Федерациясына USD жана EUR валютасында SWIFT аркылуу акча которуулар убактылуу жеткиликсиз. Альтернативдүү эсептешүүлөр боюнча Банктын бөлүмдөрүнө кайрылыңыздар',
      HINT_NAME: 'Жогорудагы тиешелүү талааларга гана "Дарек" жана "Шаарды" киргизиңиз!',
    },
    O24_TRANSFER: {
      BY_PHONE_NUMBER: 'Телефон номери боюнча',
      BY_CARD_NUMBER: 'Эсеп номери боюнча',
    },
    LOADING: {
      DRAFT: 'Төлөм черновикте сакталат',
      SIGNED: 'Төлөм кол коюуга жөнөтүлөт',
    },
    LIMITS: {
      ONE_TIME: 'Сиз бир жолку чектен ашып кеттиңиз!',
      DAILY: 'Сиз күнүмдүк чегиңизден ашып кеттиңиз!',
      MONTHLY: 'Сиз айлык чегиңизден ашып кеттиңиз!',
      FOR_DAY: 'Сиз күнүмдүк чегиңизден ашып кеттиңиз!',
      FOR_MONTH: 'Сиз айлык чегиңизден ашып кеттиңиз!',
    },
    REMOTELY_IDENTIFIED_EXCEPTION: {
      MONTHLY: {
        TITLE: 'Которуулардын айлык лимити түгөндү',
        SUBTITLE: 'Чектөөнү алып салуу үчүң аккаунттуңузду банктын кеңсесинде ырастап коюңуз',
      },
      FOR_MONTH: {
        TITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.MONTHLY.TITLE',
        SUBTITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.MONTHLY.SUBTITLE',
      },
      ONE_TIME: {
        TITLE: 'Өтө чоң суммадагы которуу',
        SUBTITLE: 'Азыраак сумманы киргизиңиз же чектөөлөрдү алуу үчүн банк кеңсесинен аккаунтуңузду ырастап коюңуз',
      },
      OPERATION_NOT_AVAILABLE: {
        TITLE: 'Өзүңүздүн карттарыңызга гана которо аласыз',
        SUBTITLE: 'Чектөөнү алып салуу үчүң аккаунттуңузду банктын кеңсесинде ырастап коюңуз',
      },
      DAILY: {
        TITLE: 'Чектөө бүткөн',
        SUBTITLE: 'Сиз Күнүмдүк чегиңизден ашып кеттиңиз!',
      },
      FOR_DAY: {
        TITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.DAILY.TITLE',
        SUBTITLE: '@:FORM_PAYMENT.REMOTELY_IDENTIFIED_EXCEPTION.DAILY.SUBTITLE',
      },
    },
    CONFIRM_TRANSFER: {
      TITLE: 'Которууну ырастаңыз',
      DESCRIPTION: 'Алмашуу курсу алдын ала көрсөтүлгөн жана эсептешүү учурунда өзгөрүшү мүмкүн',
      TRANSFER_AMOUNT: 'Которуу суммасы',
      CREDITED_AMOUNT: 'Эсепке түшкөн сумма',
      CONVERSION_RATE: 'Конвертация курсу',
    },
    EDITING: 'Төлөмдү редакциялоо',
  },
  PAYMENT_DETAILS: {
    VALUE_DATE: 'Валюталоо датасы',
    DOCUMENT: 'Документ №',
    WRITE_OFF_AMOUNT: 'Эсептен чыгаруу суммасы',
    RATE_OPERATION: 'Операция курсу',
    CREATED: 'Түзүлдү',
    ENROLLMENT_AMOUNT: 'Эсепке киргизүү суммасы',
    BANK: 'Банк',
    BIC: 'БИК',
    ACCOUNT: 'Эсеп',
    CARD_ACCOUNT: 'Карталык эсеп',
    CARD_NUM: 'Картанын номери',
    KBK: 'КБК',
    PURPOSE: 'Максатына карай',
    CORPORATE_ACCOUNT: 'Корреспонденттик эсеп',
    RECIPIENT_COUNTRY: 'Алуучунун өлкөсү',
    COMMISSION: 'Комиссия',
    COMMISSION_CURRENCY: 'Комиссиянын валютасы',
    COMMISSION_ACCOUNT: 'Комиссиянын эсеби',
    PAYMENT_CODE: 'Төлөм коду',
    OPERATION_ID: 'Операциянын IDси',
    EXOTIC_RATE: 'Экзотика курсу (USD,EUR,RUB,CNY,KZT,GBP,СNY,JPY дан сырткары)',
    OPTION: 'Опция',
  },
  PASSWORD_WITH_REPEAT: {
    THINK_UP_PASSWORD: 'Жаңы сырсөз',
    REPEAT_PASSWORD: 'Жаңы сырсөздү кайталаңыз',
    PASSWORD_MISMATCH: 'Сырсөздөр дал келбейт',
  },
  REVOCATION_REASON_PAYMENT: {
    REASON_FOR_RECALL: 'Чакыртып алуунун себеби',
    ENTER_REASON: 'Себебин жазыңыз',
  },
  SELECTION_PAYMENT_HEADER: {
    SELECT_ALL: 'Баарын тандоо',
    OPERATIONS: 'Операциялар',
    FOR_AMOUNT: 'Суммага',
    OPERATION: 'операциялар',
  },
  VISIBLE_ACCOUNT_LIST: {
    MISSING_ACCOUNT: 'Эсептер жок',
    ACCOUNT_VISIBILITY: 'Эсептин көрүнүүсү',
  },
  PAYMENT_ACTION: {
    MB_TRANSFER_SOM: 'Банк аралык сом менен которуу',
    MB_TRANSFER: 'Банк аралык валюта менен которуу',
    CONVERSION: 'Конвертациялоо',
    INTRABANK_TRANSFER: 'Банк ичиндеги которуу',
    OWN_CARD_TRANSFER: 'Бизнес картага которуу',
    O24_TRANSFER: 'Оптима24 которуу',
    CARD_RKO_TRANSFER: 'Эсептешүү эсебине Бизнес картадан которуу',
    TRANSFER_BY_INVOICE: 'Эсеп-фактураны төлөө',
    NOT_ALLOWED_BY_SIGN_RIGHT: 'Сиздин ролуңуз төлөмдөрдү түзүү мүмкүнчүлүгүн камтыбайт',
  },
  BUDGET: {
    TITLE: 'Бюджеттик төлөмдөр',
    DATE_EXPIRED:
      'Учурдагы валюталоо күнүнө карата операция түзүү мүмкүн эмес. Кийинки иш күнүнө {date} операцияны түзүүнү каалайсызбы?',
    GNS: {
      TITLE: 'МСК салык төлөмдөрү',
      OTHER_TAX: 'Башка салыктарды төлөө',
      CHATTEL_TAX: 'Кыймылдуу мүлккө салык төлөө',
      REALTY_TAX: 'Кыймылсыз мүлккө салык төлөө',
      PAYMENT: 'Төлөм коду боюнча төлөө',
    },
    TUNDUK: {
      TITLE: '"Түндүк" электрондук кызмат көрсөтүүлөр мамлекеттик порталынын кызматтарын төлөө',
    },
    AIS_FOREST_USE: '«Токой пайдалануу» АИС',
    GUARANTEE_FEE_ETP_FUGI: 'Кепилдик төлөмү (ФУГИ ЭСА)',
    E_PATENT: 'Электрондук патент',
    GUARANTEE_FEE_ETP_MSU: 'Кепилдик төлөмүн төлөө (МСУ ЭСА)',
    SOCIAL_INSURANCE_PAYMENT: 'Социалдык камсыздандыруу үчүн төлөм',
    INSURANCE_CONTRIBUTION_PAYMENT_BY_CODE: 'Төлөм коду боюнча камсыздандыруу төгүмү',
    ELECTRONIC_NOTARY: 'Электрондук нотариат',
    BUDGET_CREDIT_REPAYMENT: 'Бюджеттик кредиттерди төлөө',
    JUDICIAL_DEPARTMENT_GUARANTEE_FEE:
      'Жогорку Сотко караштуу Сот департаменти – аукционго катышуу үчүн кепилдик төлөм',
    JUDICIAL_DEPARTMENT_PROPERTY_PAYMENT: 'Жогорку Сотко караштуу Сот департаменти – мүлктүн наркын төлөө',
    JUDICIAL_DEPARTMENT_ENFORCEMENT_FEE_10_PERCENT: 'Сот департаменти – аткаруу жыйымынын 10% төлөө',
    DEADLINE_HINT:
      'Маалыматты киргизип баштагандан кийин, 15 мүнөттүн ичинде төлөмдү толтуруп, кол коюңуз. Эгер убактында кол койбосоңуз, төлөм иштетилбейт',
    SOON: 'Жакында болот!',
    PLEASE_WAIT: 'Сураныч, күтө туруңуз',
    FORM: {
      INPUT_REGION: 'Аймакты тандаңыз',
      INPUT_TAX_TYPE: 'Салык түрүн тандаңыз',
      INPUT_AMOUNT_PAYMENT: 'Сумманы киргизиңиз',
      INPUT_AIYL_AREA: 'Айыл аймагын тандаңыз',
      INPUT_WRITE_OFF: 'Чыгаруу эсеби',
      AMOUNT_PAYMENT: 'Төлөм суммасы',
      TAX_TYPE: 'Салык түрү',
      TAX_SUM: 'Салктын суммасы',
      ENICODE: 'Кыймылсыз мүлк бирдигинин коду',
      COEFFICIENT_FUNC_PURPOSE: 'Функционалдык багытынын коэффициенти',
      BOOK_VALUE: 'Баланстык наркы',
      PERSONAL_ACCOUNT: 'Өздүк эсеп',
      CODE_PAYMENT: 'Төлөм коду',
    },
    MAX_AMOUNT: 'Максималдуу сумма {value}',
    MIN_AMOUNT: 'Минималдуу сумма {value}',
    PAYMENT_DEADLINE: 'Төлөм коду түзүлгөн күндөн гана 23:59:59га чейин жарактуу.',
    PAYMENT_DEADLINE_ERROR: 'Туура төлөм кодун киргизиңиз. Кодо түзүлгөн күндөн гана 23:59га чейин иштейт.',
  },
  FOOTER: {
    COPYRIGHT: '«Оптима Банк» ААК',
    YEARS: '© 1992-{year} жж.',
  },
  LANGUAGE: {
    RU: 'Русский',
    KG: 'Кыргызча',
    ENG: 'English',
  },
  HOME: {
    TITLE: 'Башкы бет',
  },
  HISTORY: {
    TITLE: 'Операциялар',
    STATUS: {
      CREATION: 'Түзүү',
      DRAFT: 'Черновик',
      TO_DRAFT: 'Черновикке',
      PARTIALLY_CONFIRMED: 'Кол коюуда',
      PARTIALLY_CONFIRMED_SUFFIX: 'Сизге кол коюуга',
      PARTIALLY_CONFIRMED_CANCELED: 'Сизге четке кагууга',
      ON_VERIFICATION: 'Кол коюуда',
      ON_VERIFICATION_SUFFIX: 'Сизге кол коюуга',
      ON_VERIFICATION_CANCELED: 'Сизге четке кагууга',
      PARTIAL_CONFIRMATION_COMPLETED: 'Экинчи кол коюлган',
      PARTIAL_CONFIRMATION_COMPLETED_SUFFIX: 'Экинчи кол койг',
      ON_VERIFICATION_COMPLETED: '1-кол коюлган',
      ON_VERIFICATION_COMPLETED_SUFFIX: '1-кол коюлган',
      CANCELED_SIGN_TWO: '2-четке какты',
      CANCELED_SIGN_ONE: '1-четке какты',
      FOR_EDITING: 'Оңдоого жөнөтүлдү',
      REJECTED_SUFFIX: 'Сизге оңдоого жөнөтүлүдү',
      CONFIRMED: 'Кол коюлган',
      REVOKE: 'Артка чакырылган',
      WAIT_RESPONSE_FROM_BANK: 'Иштелүүдө',
      CHECK_STATUS_BANK: 'Банктын жообун текшерүү',
      PAYMENT_REQUEST_TO_BANK: 'Банкка жөнөтүлүүдө',
      KVIT: 'Банк тарабынан аткарылды',
      SUCCESS: 'Аяктады',
      ERROR: 'Банк баш тартты',
      UNKNOWN: 'Жаңылыш статус',
      FIRST_SIGN_IN_PAY_CONTROL: 'Кол коюуга жөнөтүлөт',
      FIRST_SIGN_IN_PAY_CONTROL_COMPLETE: 'Кол коюуда',
      FIRST_SIGN_IN_PAY_CONTROL_COMPLETE_SUFFIX: 'Сизге кол коюуга жөнөтүлгөн',
      SECOND_SIGN_IN_PAY_CONTROL: 'Кол коюуга жөнөтүлүп жатат',
      SECOND_SIGN_IN_PAY_CONTROL_COMPLETE: 'Кол коюуда',
      SECOND_SIGN_IN_PAY_CONTROL_COMPLETE_SUFFIX: 'Сизге кол коюуга',
      TIMEOUT_CANCELED_SIGN_TWO: 'Тайм-аут боюнча баш тартуу',
      TIMEOUT_CANCELED_SIGN_ONE: 'Тайм-аут боюнча баш тартуу',
      PARTIALLY_EXECUTED: 'Жарым жартылай аткарылган',
      TIME_IS_OUT: {
        TITLE: 'Убакыттын өтүшү менен четке кагылды',
        ERROR: 'Төлөм убактысы боюнча текшерүүдөн өткөн жок, дагы бир аракет кылып көрүңүз',
      },
    },
    STATUS_HISTORY: {
      DRAFT: 'Түзүлдү',
      PARTIAL_CONFIRMATION_COMPLETED: '2-чи кол койгон',
      ON_VERIFICATION_COMPLETED: 'Кол коюлган',
      ON_VERIFICATION_COMPLETED_SUFFIX: '1-чи кол койгон',
      CANCELED_SIGN_TWO: '2-чи четке какты',
      CANCELED_SIGN_ONE: '1-чи четке какты',
      WAIT_RESPONSE_FROM_BANK: 'Иштелүүдө',
      PAYMENT_REQUEST_TO_BANK: 'Аткаруу өтүнүчү',
      TIMEOUT_CANCELED_SIGN_TWO: 'Тайм-аут боюнча баш тартуу',
      TIMEOUT_CANCELED_SIGN_ONE: 'Тайм-аут боюнча баш тартуу',
      REVOKE: 'Чакырып алынган',
      KVIT: 'Банк тарабынан аткарылд',
      SUCCESS: 'Аяктады',
      ERROR: 'Четке кагылды',
    },
    LISTS: {
      ALL: 'Баары',
      DRAFT: 'Менин черновиктерим',
      FAILED: 'Четке кагылгандар',
      DRAFT_SALARY: 'Кол коюуга даяр',
      ERROR: 'Банк тарабынан четке кагылды',
      FOR_SIGN: 'Кол коюуга',
      FOR_EDITING: 'Редакциялоого',
      SUCCESS: 'Аткарылгандар',
    },
    NOTIFICATIONS: {
      SIGNED: {
        SUCCESS: 'Төлөмгө {number} кол коюлду',
        SUCCESS_MULTIPLE: 'Төлөмдөргө кол коюлду',
        SUCCESS_PARTIAL: 'Төлөмдөргө жарым-жартылай кол коюлду',
        ERROR: 'Төлөмгө кол коюлбай калды',
        ERROR_MULTIPLE: 'Төлөмдөргө кол коюлбай калды',
      },
      SEND_TO_SIGNED: {
        SUCCESS: 'Төлөм {number} кол коюуга жөнөтүлдү',
        SUCCESS_MULTIPLE: 'Төлөмдөр кол коюуга жиберилди',
        ERROR: 'Төлөмдү кол коюуга жөнөтүү мүмкүн болгон жок',
        ERROR_AFTER_DRAFT: 'Операция черновик катары түзүлгөн жана операциялар тарыхынан кол коюлууга тийиш',
        ERROR_MULTIPLE: 'Төлөмдөрдү кол коюуга жөнөтүүгө мүмкүн болгон жок',
      },
      SAVED_TO_DRAFT: {
        SUCCESS: 'Төлөм {number} черновикте сакталды',
        ERROR: 'Төлөмдү черновикте сакталбай калды',
      },
      DELETE_DRAFT: {
        SUCCESS: 'Черновик {number} өчүрүлдү',
        ERROR: 'Черновик өчүрүлбөй калды',
      },
      FOR_EDITING: {
        SUCCESS: 'Төлөм {number} четке кагылды',
        ERROR: 'Төлөмдү четке кагууга мүмкүн болгон жок',
      },
      SEND_TO_EDITING: {
        SUCCESS: 'Төлөм {number} редакциялоого жөнөтүлдү',
        ERROR: 'Төлөм редакциялоого жөнөтүүгө мүмкүн болгон жок',
      },
      SUCCESS_EDITING: {
        SUCCESS: 'Төлөм ийгиликтүү оңдолду',
        ERROR: 'Төлөмдү ийгиликтүү оңдоого мүмкүн болгон жок',
      },
    },
    TRANSACTION: {
      PAYMENTS_SIGNED: 'Төлөмдөргө кол коюлууда...',
      PAYMENT_SIGNED: 'Төлөм № {number} кол коюлууда...',
      PAYMENT_CANCELLED: 'Төлөм № {number} четке кагылууда...',
      PAYMENT_SENT_EDITING: 'Төлөм № {number} редакциялоого жөнөтүлүүдө...',
      PAYMENT_SENT_SIGNING: 'Төлөм № {number} кол коюуга жөнөтүлүүдө...',
      FILE_DOWNLOADING: 'Файл жүктөлүүдө...',
      FILE_OPENING: 'Файл ачылууда...',
      PAYMENT_REMOVING: 'Төлөм № {number} өчүрүлүүдө...',
      PAYMENT_SENT_SIGN: 'Төлөм кол коюуга жөнөтүлүүдө...',
      PAYMENTS_SENT_SIGN: 'Төлөмдөр кол коюуга жөнөтүлүүдө...',
      PAYMENTS_RESPOND: 'Төлөмдөр артка чакырып алынууда...',
      PAYMENT_RESPOND: 'Платеж отзывается...',
      PAYMENT_UPDATING: 'Төлөм № {number} жаңыртылууда...',
      PAYMENT_RECALL: 'Төлөм редакциялоого кайтарылды',
      PAYMENT_RECALLING: 'Төлөм кайтарылып жатат...',
      ERROR: {
        FOR_SIGN: 'Кол коюуга жөнөтүү мүмкүн болгон жок',
        PAYMENT_RECALL: 'Төлөм кайтарылбады',
      },
    },
  },
  FILE_UPLOAD: {
    LOADING: 'Файлды жүктөө...',
    FILE_SIZE_EXCEPTION: 'Файлдын өлчөмү уруксат берилген мааниден ашып жатат.',
    FILE_EXTENSION_EXCEPTION: 'Файлдын кеңейтилиши күтүлгөнгө шайкеш келбейт.',
    FILE_SAVED_SUCCESSFULLY: 'Файл ийгиликтүү сакталды',
    IN_IMPORTED: 'Импорттолгондорго',
    FAILED_SAVE_FILE: 'Файл сакталбай калды',
  },
  HISTORY_PAYMENT_QR: {
    EXTRACT_FORMAT: 'Форматты тандаңыз',
    DOWNLOAD_STATEMENT: 'Көчүрмөнү көчүрүү',
    TITLE: 'QR-код менен төлөмдөр',
    EXTRACT_EXCEL: 'Excel экспорттоо',
    VALIDATION_ERROR_DATE: 'Excelге экспорттоо үчүн чыпкада эки күндү же убакыт мезгилин көргөзүңүз',
    ENROLLED: 'Чегерилди',
    TYPE_TRANSACTION: 'Транзакциянын түрү',
    TYPE_QR_POS: 'QR түрү жана POS-терминал номери',
    POS_NUMBER: 'POS-терминал номери',
    QR_SERVICE_TYPE: {
      STATIC: 'Статикалык',
      DYNAMIC: 'Динамик',
      OVERHEAD: 'Товар коштомо кагазы боюнча төлөө',
      WEB: 'Онлайн төлөмдөрүн төлөө',
      MONITOR: 'Кассада оффлайн төлөө',
      INVOICE: 'Төлөм эсеби',
      PERSONAL_QR_WEB: 'Жеке QR',
      DEEPLINK_QR: 'Диплинк QR',
    },
    STATUS_SUCCESS: 'Аткарылды',
    PAYMENT_FOR_OPTIMA_QR: '{senderName}дан OptimaQR боюнча төлөм',
    PAYMENT_FOR_QR: 'QR-код боюнча төлөм',
    EMPTY_HISTORY: 'Операциялардын тизмеси бош',
    SORTED: {
      TITLE: 'Суммасы боюнча сорттоо',
      NONE: 'Сорттоосуз',
      ASC: 'Көбөйүшүнө жараша',
      DESC: 'Азайышына жараша',
    },
    DATE_PERIOD: {
      RECENT: 'Акыркы',
      WEEK: '7 күндө',
      MONTH: '30 күндө',
    },
    INCOME_TODAY: 'Бүгүнкү киреше',
    INCOME_YESTERDAY: 'Кечээки киреше',
    SALES_SHORT_LABEL: 'Сатуулардын саны',
  },
  QR_REFUND: {
    ABOUT: 'Кайтаруу тууралуу',
    OUTLET_NAME_OR_ACCOUNT: 'Сатуу түйүнү аты',
    OUTLET_ADDRESS: 'Түйүндүн дареги',
    RETURNED: 'Кайтарылды',
    TO_RETURN: 'Кайтарууга',
    TO_CLIENT: 'Кардарга кайтаруу',
    TO_CARD: 'Картага кайтаруу',
    TO_REFUND_CHECK: 'Кайтаруу чек',
    CHECK_NUMBER: 'Чектин номери',
    RETURN_CHECK_NUMBER: 'Кайтарылма чектин номери',
    SUM: 'Кайтаруунун суммасы',
    PURPOSE: 'Кайтаруунун себеби',
    HINT: 'Сиз бирден ашык эмес толук же жарым-жартылай кайтарып бере аласыз  ',
    ONLY_O24: 'Кайтаруу бир гана OptimaQR аркылуу',
    ALREADY_RETURNED: 'Бул төлөм боюнча каражат кайтарылган',
    IN_PROCESS: 'Кайтаруу буга чейин кол коюуга жөнөтүлгөн',
    RULES: {
      AMOUNT: 'Кайтаруу суммасы баштапкы төлөм суммасынан көп болбошу керек',
      PURPOSE: 'Талаага 4төн 140ка чейин символдорду жазса болот, төмөнкүлөрдөн башка: \\ «» & <>',
    },
    ERRORS: {
      PAYER_ACCOUNT_NOT_ENOUGH_MONEY: 'Чыгаруу эсебинде акча жетишсиз',
      PAYER_ACCOUNT_NOT_ENOUGH_MONEY_HINT: 'Эсепти толуктап, кайтарууну кайра жасап көрүңүз',
      PAYER_ACCOUNT_BLOCKED: 'Чыгаруу эсеби бөгөттөлгөн',
      PAYER_ACCOUNT_BLOCKED_HINT:
        'Эгер сиз ээси болсоңуз, эсепти бөгөттөн чыгаруу үчүн {department} кеңсесине кайрылыңыз',
      RECIPIENT_ACCOUNT_BLOCKED: 'Чегерүү эсеби бөгөттөлгөн',
      RECIPIENT_ACCOUNT_BLOCKED_HINT: 'Эсепти бөгөттөн чыгаруу үчүн кардарды колдоо кызматына кайрылуусун сураныңыз',
      RECIPIENT_ACCOUNT_INACTIVE: 'Чыгаруу эсеби активдүү эмес',
    },
  },
  QR_PAYMENT: {
    TITLE: 'QR-код аркылуу төлөм',
    SUBTITLE: 'QR аркылуу төлөм',
    B2C_O24: 'OptimaQR аркылуу B2C төлөмү',
    B2B_O24: 'OptimaQR аркылуу B2B төлөмү',
    B2B_ELQR: 'ELQR аркылуу B2B төлөмү',
    B2G: 'B2G төлөмү',
  },
  SETTINGS: {
    TITLE: 'Орнотуулар',
    MAIN: {
      PAY_CONTROL: 'Pay Control',
      VISIBILITY_ACCOUNT: 'Эсептердин көрүнүшү',
      CHANGE_PHONE: 'Телефон номерин өзгөртүү',
      CODE_WORD: 'Купуя сөз',
      COMPANY: {
        TITLE: 'Компания жөнүндө',
        ID_COMPANY: 'Компаниянын ID',
        NAME: 'Аталышы',
        SIGN_TYPE: 'Кол тамганын түрү',
        SIGN_SCHEME: 'Төлөмдөр маршруту',
        DEPARTMENT_NAME: 'Келишимдин филиалы',
        REGISTER_DATE: 'Келишим катталган датасы',
      },
      PRIVATE: {
        TITLE: 'Жеке маалыматтар',
        NAME: 'ФАА',
        RIGHTS: 'Ролу',
        EMAIL: 'Эл.дарек',
        PHONE: 'Телефон номери',
      },
      CONTACTS: {
        TITLE: 'Банк контакттары',
        WHATS_APP: 'WhatsApp',
        PHONE: 'Тел.',
        EMAIL: 'E-mail',
      },
      PAYMENT: {
        TITLE: 'Убакыт регламенти',
        SUBTITLE: 'Оptima Businessтеги операциялар үчүн убактылуу чектөөлөр:',
        DESCRIPTION:
          'Сураныч, Оптима Бизнесте операцияларды жүргүзүүдө көрсөтүлгөн убакыт чектерине көңүл буруңуз. Бул чектөөлөрдү кармануу операцияны иштеп чыгуудагы мүмкүн болгон кечигүүлөрдү алдын алууга жардам берет.',
        TYPE: {
          CLEARING: 'Клиринг',
          GROSS: 'Гросс',
          SWIFT: 'SWIFT',
          INTRABANK_TRANSFER_OWN: 'Өзүнүн эсептеринин ортосунда которуу',
          INTRABANK_TRANSFER_FOREIGN: 'Башка кардарлардын эсептерине которуу',
          RKO_2_BUSINESS_CARD_OWN: 'Бизнес картка которуу',
          INTRABANK_TRANSFER_RKO_2_CARD_OWN: 'Бизнес картка которуу',
          RKO_2_BUSINESS_CARD_FOREIGN: 'Optima24кө которуу',
          RKO_2_INDIVIDUAL_CARD_FOREIGN: 'Optima24кө которуу',
          RKO_2_INDIVIDUAL_CARD_OWN: 'Optima24кө которуу',
          BUSINESS_CARD_2_RKO_OWN: 'Эсептешүү эсебине бизнес картдан которуу',
          BUSINESS_CARD_2_RKO_FOREIGN: 'Эсептешүү эсебине бизнес картдан которуу',
          CONVERSION: 'Конвертациялоо',
          BUDGET_PAYMENT: 'Бюджеттик төлөмдөр',
          SALARY: 'Эмгек акы долбоору',
          TRANSFER_BY_INVOICE: 'Төлөм эсебин төлөө',
          REFUND: 'QR төлөмүн кайтаруу',
          QR: 'QR аркылуу төлөм/которуу',
        },
        DEFAULT: 'Башка валюталар',
        CREATE_OPERATION: 'Операцияны түзүү',
        SIGN_OPERATION: 'Операцияга кол коюу',
        TIME: '{value} чейин',
      },
    },
    CHANGE_PASSWORD: {
      TITLE: 'Сырсөздү алмаштыруу',
      SUCCESSFULLY: 'Сырсөз өзгөртүлдү',
      FAILED: 'Сырсөз өзгөртүлгөн жок',
      CURRENT_OPT_INCORRECT: 'Учурдагы сырсөз же TOTP-код туура эмес!',
      LOGIN_OB: 'Сырсөз Optima Business кирүү үчүн колдонулат',
      CURRENT: 'Учурдагы сырсөз',
    },
    CHANGE_PHONE: {
      NUMBER_OB: 'Optima Businessте телефон номерин алмаштыруу',
      SUCCESSFULLY: 'Телефон номери өзгөртүлдү',
      TRY_ENTER_NEW: 'Жаңысын киргизип көрүңүз',
      ENTER_CODE_SENT: 'Жаңы телефон номерине жөнөтүлгөн кодду жазыңыз',
      NEW_OLD_SAME: 'Жаңы телефон номери мурда катталган номерди кайталайт',
      REGISTERED: 'Катталган телефон номери',
      NEW: 'Жаңы телефон номери',
      SMS_CODE: 'СМС-код',
    },
    VISIBILITY_ACCOUNT: {
      FAILED_CHANGE_ACCOUNT_VISIBILITY: 'Эсептин көрүнүү орнотуулары өзгөртүлгөн жок',
      FAILED_GET_INVOICES: 'Эсептерди алууга мүмкүн болгон жок',
    },
    PAY_CONTROL: {
      INFO: 'Pay Control боюнча маалымат',
      REGISTRATION: 'Pay Control каттоо',
      SUCCESS_GENERATED: 'Pay Control ийгиликтүү түзүлдү',
      ERROR: 'Pay Control түзүүдө ката чыкты',
      IDENTIFIER: 'Идентификатор:',
      VALIDITY: 'Жарактуу мөөнөтү:',
      REISSUE_KEY: 'Ачкычты кайра чыгаруу',
      RELEASE_KEY: 'Ачкычты чыгаруу',
    },
    API_KEY: {
      TITLE: 'Ачкыч (API Key)',
      HELP: {
        LABEL: 'API Key деген эмне',
        DESCRIPTION:
          'Бул шифрленген түрдө маалыматтарды алмашууга мүмкүндүк берген тамгалардан жана сандардан турган код',
      },
      DIALOG: {
        SAVE: {
          TITLE: 'API Key ачкычын сактаганыңызды тастыктаңыз',
          MESSAGE: '"Ачкыч көчүрүлдү жана сакталды" басып, анан "Даяр" баскычын басыңыз',
        },
        WARNING: {
          TITLE: 'Ачкычты кайрадан түзгүңүз келеби?',
          MESSAGE: 'Кайра түзүү учурдагы активдүү ачкычты жок кылат',
        },
      },
      HINT: 'Ошондо Сиз ага жеткиликтүүлүк аласыз. Ачкыч 90 күн активдүү',
      KEY: 'Ачкыч',
      KEY_TYPE: 'Ачкычтын түрү',
      KEY_STATE: {
        ACTIVE: 'Активдүү',
        INACTIVE: 'Сиздин ачкыч активдүү эмес',
        NEW: 'Жаңы ачкыч',
      },
      CATEGORIES: {
        QR: 'QR Түзүү',
        QR_DATA_REQUEST: 'QR төлөмү боюнча маалыматка сурам жөнөтүү',
        OUTLET: 'Сатуу упайларынын тизмеси жана касс',
        POS_OPERATION_STATEMENT: 'POS жана QR-төлөмдөр боюнча көчүрмө',
        QR_OPERATION_STATEMENT: 'QR-төлөмдөр боюнча көчүрмө',
      },
      KEY_COPY: 'API Key ачкычты көчүрүп, сактаңыз',
      KEY_COPIED: 'Ачкыч көчүрүлдү жана сакталды',
      CHOOSE_CATEGORY: 'Категорияны тандаңыз',
      VALID_UNTIL: 'Активдүүлүктүн аягы',
      CATEGORY: 'Категория',
    },
    TOTP_CONTAIN_SIX_DIGITS: 'TOTP-код 6 цифрадан туруш керек',
    SET: 'Орнотуулар',
  },
  CHECK_TYPES: {
    UPP_LOW_CASE_LATIN: 'чоң жана кичине латын тамгалары',
    NUMBERS: 'сандар',
    SYMBOLS: "символдор {'.!@#$%^&*-'}",
    BETWEEN_CHARACTERS: '8ден 255 символго чейин',
  },
  EXTRA_SETTINGS: {
    TITLE: 'Дагы',
    SUBTITLE: 'Колдоо кызматы',
    CATEGORIES: {
      PRODUCTS: 'ӨНҮМДӨР',
      MAIN: 'НЕГИЗГИ',
      COMMUNICATION: 'БАНК МЕНЕН БАЙЛАНЫШУУ',
    },
    NAV: {
      FAQ: {
        TITLE: 'Жардам',
        DESCRIPTION: 'Кайталануучу суроолор жана аларга жоопторм',
        USER_GUIDE: 'Колдонуучунун колдонмосу',
      },
      CALL_CENTER: {
        TITLE: 'Колдоо кызматы',
        DESCRIPTION: '7711 акысыз',
      },
    },
  },
  MORE: {
    TITLE: 'Дагы',
    SUB_TITLE: 'Банк менен байланышуу',
  },
  ACCOUNT: {
    TITLE: 'Менин эсептерим',
    STATUS_TITTLE: {
      OPEN: 'Ачык',
      CLOSED: 'Жабык',
      ARRESTED: 'Камакка алуу',
      FINAL_ARRESTED: 'Тосмолонду',
    },
    CURRENT: 'Учурдагы эсеп',
    EMPTY: 'Жеткиликтүү эсептер жок',
    EMPTY_BY_ACCESS: 'Сизде төлөмдөрдү ишке ашырууга уруксат жок, {company_name} жетекчилигине кайрылыңыз',
    MULTI_CURRENCY_REQUIRED:
      'Бул операцияны аткаруу үчүн мультивалюталык эсеп талап кылынат. Аны банктын бөлүмүнөн ача аласыз.',
    SEVERAL_ACCOUNTS_REQUIRED:
      'Эсептер арасында которуу жүргүзүү үчүн сизде бир нече эсептешүү эсеби ачылган болушу керек. Кошумча эсепти банктын каалаган бөлүмүнөн ача аласыз.',
    ERROR: 'Эсептер алынбай калды',
    AVAILABLE_BALANCE_DETAILS: {
      TITLE: 'Эсеп боюнча толук маалымат',
      ACTUAL: 'Фактикалык калдык',
      PENDING_TOTAL: 'Кол коюлуп жаткан жана иштетилүүдөгү төлөмдөрдүн жалпы суммасы:',
      PAYMENT_COUNT: 'төлөм жок | {n} төлөм | {n} төлөм | {n} төлөм',
      SIGNING_LABEL: 'Кол коюлууда:',
      SIGNING_LABEL_MOBILE: 'Optima Businessте кол коюлууда:',
      PROCESSING_LABEL: 'Иштетилүүдө:',
      AVAILABLE: 'Жеткиликтүү калдык',
    },
  },
  DOCUMENTS: {
    TITLE: 'Документтер',
    REQUISITES: {
      NAV: 'Реквизиттер',
      FILES: {
        FILE_ONE: {
          TITLE: 'Банктар аралык кириш которууну эсепке салуу үчүн реквизиттер',
          DOWNLOAD: 'Жүктөп алуу',
          SHARE: 'Бөлүшүү',
        },
      },
      DOWNLOADING: 'Файл жүктөлүүдө',
      ERROR: 'Реквизиттер жүктөлбай калды',
    },
    STATEMENT_ACCOUNT: {
      TITLE: 'Көчүрмөлөр',
      NAV: 'Көчүрмөлөр',
      DOWNLOAD_PDF: 'PDF файлды жүктөө',
      DOWNLOAD_XLSX: 'Excel файлды жүктөө',
      DOWNLOADING: 'Файл жүктөлүүдө',
      ORDER_FORMED: 'Файл түзүлүүдө',
      ORDER: {
        EXTRACT: 'Көчүрмөнү түзүү',
        OPTIONS: 'Көчүрмө үчүн параметрлер',
        VIEW: 'QR боюнча жандырмак',
        WITHOUT_QR_DETAILS: 'QR-операциянын жандырмагысыз',
        WITH_QR_DETAILS: 'QR-операциянын жандырмагы менен кошо',
        MULTIPLE_CURRENCY: 'Бир нече валютаны тандаса болот',
        DATE_FROM: 'Баштап',
        DATE_TO: 'Чейин',
        PERIOD_FILTER: {
          TITLE: 'Мезгил боюнча чыпка',
          BY_REIMBURSEMENT: 'Эсепке кайтарылган күнү боюнча',
          BY_TRANSACTION_DATE: 'Транзакциянын күнү боюнча',
          REIMBURSEMENT_DESCRIPTION: 'Кайтарылган күнү боюнча — каражаттардын эсептик эсепке же картага түшкөн күнү',
          TRANSACTION_DESCRIPTION: 'Транзакциянын күнү боюнча — төлөм жүргүзүлгөн күн',
        },
      },
      STATUS: {
        IN_PROGRESS: 'В процессе',
        READY: 'Көчүрмө түзүлдү',
        NOT_FOUND: 'Көрсөтүлгөн мезгилде көчүрмө үчүн маалымат жок',
        FAIL: 'Түзүү мүмкүн болгон жок',
        PENDING: 'Күтүүдө',
      },
      COLUMN_TABLE: {
        ACCOUNT: 'Эсеп номери',
        PERIOD: 'Көчүрмө убактысы',
        REQUEST_DATE: 'Өтүнмөнүн датасы',
      },
      ALL_ACCOUNT: 'Бардык эсептер боюнча',
      EMPTY: 'Сизде түзүлгөн көчүрмөлөр жок.\n«Көчүрмө түзүү» баскычын басып түзүңүз.',
      HAS_NOT_POS: 'Сизде түзүлгөн көчүрмөлөр жок.\n' + '«Көчүрмө түзүү» баскычын басып түзүңүз.',
      ERROR: 'Көчүрмө алуу мүмкүн эмес',
      ORDER_EXTRACT: {
        IN_PROCESSING: 'Көчүрмө түзүү өтүнүчү иштеп чыгууга кабыл алынды',
        FAIL: 'Эсеп көчүрмөсүн түзүү мүмкүн болгон жок',
      },
      OUTLET: {
        SELECT_ALL_OUTLET: 'Баардык сатуу түйүндөрү',
        SELECT_ALL_POS: 'Баардык POS-терминалдар',
        SELECT_ALL_POS_AND_KIOSKS: 'Баардык POS + киосктор',
        POS_NUMBER: 'POS-терминалынын номери',
      },
      RANGE_DATE: {
        TODAY: 'Бүгүн',
        YESTERDAY: 'Кечээ',
        WEEK: 'Жума',
        MONTH: 'Ай',
      },
    },
    DEVICE_STATEMENTS: {
      NAV: 'Түзмөк боюнча көчүрмөлөр',
      DEVICE_NAME: 'Соода чекитинин аталышы',
      POS_NUMBER: 'Түзмөктүн номери (POS)',
    },
  },
  EMPLOYEES: {
    TITLE: 'Кызматкерлер',
    SALARY: {
      SAVED_SUCCESSFULLY: 'Роль жөндөөсү өзгөртүлдү',
    },
    DETAILS: {
      ACCOUNT_SETTINGS: 'Эсептердин орнотуулары',
      EMPLOYEE: 'Кызматкер:',
      ROLE: 'Ролу:',
      ACCOUNT_NUMBER: 'Эсеп номери',
      TREATY: 'Келишим',
      ACCOUNTS: {
        TITLE: 'Эсептер',
        SAVED_SUCCESSFULLY: 'Эсептин орнотуулары өзгөртүлдү',
        ACCOUNTS_EMPTY: 'Жок',
      },
      POINT_ACCESS: {
        TITLE: 'Түйүндөргө жеткиликтүүлүк',
        SUBTITLE: 'Түйүндөргө жеткиликтүүлүктү ачыңыз',
        ENABLE_ALL: 'Бардык түйүндөрдү күйгүзүү',
        SEARCH_PLACEHOLDER: 'Соода түйүнүнүн аталышы',
      },
    },
    LIST: {
      FULL_NAME: 'ФАА',
      PHONE_NUMBER: 'Телефон номери',
      ROLE: 'Ролу',
      DATE_OF_REGISTRATION: 'Катто күнү',
      MISSING_EMPLOYEES: 'Кызматкерлер жок',
    },
    STATUS: {
      ACTIVE: 'Активдүү',
      FREEZE: 'Бөгөттөлгөн',
    },
    ROLE: {
      CREATOR: 'Аткаруучу',
      FIRST: '1чи кол коюу укугу',
      SECOND: '2чи кол коюу укугу',
      AUDITOR: 'Аудитор',
      NONE: 'Колу жок',
      CASH_MANAGER: 'Менеджер',
      CASHIER: 'Кассир',
    },
    SETTINGS: {
      ERROR: 'Кызматкерлердин тизмесин алуу мүмкүн болгон жок',
    },
  },
  IMPORTED: {
    TITLE: 'Импорттолгон',
    FILE_NAME: 'Файлдын аты',
    DATE_DOWNLOAD: 'Жүктөө күнү',
    CREATE_OPERATION: 'Операцияларды түзүү',
    RETRY_UPLOAD: 'Файлды жүктөөнү кайталоо',
    FAILED_IMPORTED: 'Импорт файлдарды алуу мүмкүн эмес',
    GO_OPERATION: 'Операцияга өтүү',
    CAUSE: 'Себеби',
    PAYMENT_PROCESSING: 'Төлөмдү иштетүү',
    STATUS_FILE: {
      PROCESSED: 'Иштелди',
      REJECTED: 'Четке кагылды',
      ERROR_PROCESSING: 'Иштөөдө ката кетти',
      PREPARING: 'Түзүлүүдө...',

      PAYMENT: {
        PROCESSING: 'Иштелүүдө',
        UNPROCESSABLE: 'Файлдын мазмунун текшериңиз',
        FAILED: 'Операция түзүүдө ката кетирилди',
        DENIED: 'Операция түзүү четке кагылды',
        UPLOADING: 'Операцияларды түзүү...',
        UPLOADED: 'Операциялар түзүлдү',
        EDITED: 'Бул операция өзгөрүлгөн',
        ERROR_UPLOADING: 'Операция түзүүдө ката кетирилди',
        PARTIALLY_PROCESSED: 'Жарым-жартылай иштетилди',

        FILE_VALIDATION_PROCESSING: 'Ведомостту текшеребиз…',
        FILE_VALIDATION_FINISHED: 'Ведомость жайында',
        FILE_VALIDATION_ERROR: 'Маалыматтарды текшериңиз',
        BUSINESS_VALIDATION_PROCESSING: 'Реквизиттерди текшеребиз...',
        BUSINESS_VALIDATION_FINISHED: 'Реквизиттер жайында',
        BUSINESS_VALIDATION_ERROR: 'Эсептен чыгаруу жана которуу эсептерин текшериңиз',
        SALARY_CREATION_PROCESSING: 'Ведомость түзөбүз…',
        SALARY_CREATION_FINISHED: 'Ведомость жана төлөм системасын түздү',
        SALARY_CREATION_ERROR: 'Бир нерсе туура эмес болуп кетти. Дагы бир жолу аракет кылыңыз',
        ERROR_CONFIRMED: 'Архивде',
        PROCESSING_COMPLETED: 'Кол коюуга даяр',
      },
      SALARY: {
        PROCESSING: 'Иштелүүдө',
        UNPROCESSABLE: 'Төлөмдү иштеп чыгууга мүмкүн  болбой жатат',
        FAILED_PREPARING: 'Калыптандыруу учурунда ийгиликсиз аракет',
        ERROR_PREPARING: 'Калыптандыруу учурундагы ката',
        READY_FOR_EXECUTION: 'Аткарууга даяр',
      },
    },
    STATUS_PAYMENT: {
      OK: 'Иштетилди',
      REJECTED: 'Четке кагылды',
    },
    EMPTY: 'Файлдар табылган жок',
    CHOOSE_FILE_TYPE: {
      TITLE: 'Типти тандаңыз',
      LABEL: 'Сураныч, суммасы 1 миллион сомдон төмөн же барабар болгон банктар аралык которуулар үчүн типти тандаңыз',
    },
    WARNING: '*суммасы 1 миллион сомдон жогору которуулар автоматтык түрдө Гросс тибинде жөнөтүлөт',
  },

  PAYMENT: {
    TITLE: 'Төлөм',
    FOR_SIGN: 'Кол коюу үчүн төлөмдөр',
    NO_ACCESS_OPERATION: {
      TITLE: 'Керектүү эсепти таба албадыңызбы?',
      DESCRIPTION: 'Сизде ага жеткиликтүүлүк жок. 1-кол коюучудан сизге укук берүүсүн сураныңыз.',
      MANAGER_HINT: 'Жетекчи кантип уруксат берет:',
      STEPS:
        'Жөндөөлөр → Кызматкерлер → Керектүү кызматкерди тандаңыз → Керектүү эсепти тандаңыз → Керектүү операция үчүн тумблерди күйгүзүңүз.',
    },
    TYPE: {
      CLEARING: 'Клиринг',
      GROSS: 'Гросс',
      CLEARING_GROSS: 'Клиринг/Гросс',
      SWIFT: 'SWIFT',
      INTRABANK_TRANSFER_OWN: 'Өзүнүн эсептеринин ортосунда которуу',
      INTRABANK_TRANSFER_FOREIGN: 'Башка кардарлардын эсептерине которуу',
      INTRABANK_TRANSFER_RKO_2_CARD_OWN: 'Бизнес картка которуу',
      RKO_2_BUSINESS_CARD_OWN: 'Бизнес картка которуу',
      RKO_2_BUSINESS_CARD_FOREIGN: 'Optima24кө которуу',
      RKO_2_INDIVIDUAL_CARD_FOREIGN: 'Optima24кө которуу',
      RKO_2_INDIVIDUAL_CARD_OWN: 'Optima24кө которуу',
      BUSINESS_CARD_2_RKO_OWN: 'Эсептешүү эсебине Бизнес картдан которуу',
      BUSINESS_CARD_2_RKO_FOREIGN: 'Эсептешүү эсебине Бизнес картдан которуу',
      INTRABANK_TRANSFER_BUSINESS_CARD_2_RKO_OWN: 'Бизнес картдан өз эсептериңе которуу',
      INTRABANK_TRANSFER_BUSINESS_CARD_2_RKO_FOREIGN: 'Бизнес картдан башка эсептешүү эсептерге которуу',
      CONVERSION: 'Конвертациялоо',
      BUDGET_PAYMENT: 'Бюджеттик төлөм',
      REFUND: 'QR төлөмдү кайтаруу',
      TRANSFER_BY_INVOICE: 'Төлөм эсебин төлөө',
      NO_TITLE: 'Аталышы жок',
      BETWEEN_ACCOUNTS: 'Өз эсептеринин ортосунда',
      INTRABANK_TRANSFER: 'Банк ичиндеги которуу',
      VIEW_ACCOUNT: 'Эсепти карап чыгуу',
      VIEW_LOAN_CLAIM: 'Насыя боюнча маалыматты көрүү',
      SALARY: 'Айлык акы долбоору',
      QR: 'QR аркылуу төлөм/которуу',
    },
    ORIGIN: {
      ALL: 'Баары',
      MANUAL: 'Колдонуучунун',
      DIRECT_BANK: '1C',
      FILE: 'Импорттолгон',
    },
    NOTIFICATIONS: {
      MESSAGE: {
        ERROR: {
          TITLE: 'Төлөм <span class="text-primary">банк тарабынан четке кагылды</span>',
          TITLE_TEXT: 'Төлөм банк тарабынан четке кагылды',
          TEXT: '"{operationCode}" №{transferNum} суммасы {amount} {currency}',
        },
        PAYMENT_REQUEST_TO_BANK: {
          TITLE: 'Төлөм <span class="text-primary">банк тарабынан</span>',
          TITLE_TEXT: 'Төлөм банк тарабынан четке кагылды',
          TEXT: '"{operationCode}" №{transferNum} суммасы {amount} {currency} \n( {text} )',
        },
      },
    },
    TEMPLATES: {
      TITLE: 'Шаблондор',
      NAME: 'Шаблондордун аталышы',
      SEARCH: 'Шаблондорду издөө',
      CREATED: 'Шаблон сакталды',
      EDIT: 'Шаблонду өзгөртүү',
      EDITING: 'Шаблонду өзгөртүү',
      EDITED: {
        SUCCESS: 'Шаблон өзгөртүлдү',
        ERROR: 'Шаблонду өзгөртүүгө мүмкүн болгон жок',
      },
      DELETE: 'Шаблонду өчүрүү',
      DELETED: 'Шаблон өчүрүлдү',
      NOT_FOUND: 'Шаблондор табылган жок',
      CREATE: 'Жаблонду түзүү',
    },
    DIALOG: {
      EXIT: {
        TITLE: 'Сиз чын эле төлөм процессинен чыккыңыз келеби?',
        LABEL: 'Эгер азыр чыксаңыз, киргизилген бардык дайындар жоголуп кетиши мүмкүн.',
      },
    },
  },
  STATEMENT: {
    TRANSACTION: {
      DATE: {
        TODAY: 'Бүгүн',
        TODAY_TIME: 'Бүгүн {time} убакытта',
        YESTERDAY: 'Кечээ',
        YESTERDAY_TIME: 'Кечээ {time} убакытта',
      },
      EMPTY: {
        SUCCESS: 'Аяктаган операциялар жок',
        ON_SIGN: 'Кол коюу үчүн операциялар жок',
        REJECTED: 'Четке кагылган операциялар жок',
        ERROR: 'Банк тарабынан четке кагылган операциялар жок',
        FOR_EDITING: 'Өзгөртүүгө операциялар жок',
        DRAFT: 'Черновиктердин тизмеси бош',
      },
      EMPTY_STATEMENT: 'Операциялар тизмеси бош',
      DELETE: 'Өчүрүү',
      DOWNLOAD: 'PDFте жүктөө',
      DOWNLOAD_STATEMENT: 'Көчүрмөнү жүктөө',
      SCHEME: 'Схеманын көрсөтүү',
      GET: 'Жүктөө',
      OPEN: 'Ачуу',
      EDIT: 'Редакциялоого',
      EDIT_ALL: 'Баарын редакциялоого',
      CHANGE: 'Редакциялоо',
      REPEAT: 'Кайталоо',
      REVOKE: 'Четке кагуу',
      REVOKE_ALL: 'Баарын четке кагуу',
      SIGN: 'Төлөмгө кол коюу',
      SIGN_ALL: 'Баарына кол коюу',
      SEND_FOR_SIGN: 'Баарын кол коюуга жиберүү',
      SEND_AFTER_CHANGE: 'Кол коюуга жиберүү',
      RECALL: 'Кайтарып алуу',
      PRINT: 'Басып чыгаруу',
    },
    TRANSFER_ACTIONS: {
      DELETE: 'Өчүрүү',
      EDIT: 'Төлөмдү редакциялоо',
      EDITING: 'Төлөмдү редакциялоо',
      CHANGE: 'Редакциялоо',
      REPEAT: 'Кайталоо',
      REVOKE: 'Четке кагуу',
      SIGN: 'Кол коюу',
      TITLE: 'Төлөмдүн деталдары',
      FOR_SIGN: 'Кол коюуга',
      RECALL: 'Төлөмдү кайтарып алуу',
    },
    NOTIFICATIONS: {
      TITLE: 'Көчүрмө',
      TITLE_MANY: 'Көчүрмөлөр',
      OK: 'Ок',
      GO_ON: 'Өтүү',
      MESSAGE: {
        READY: 'Көчүрмө түзүлдү',
        FAIL: 'Көчүрмө түзүлгөн жок',
        NOT_FOUND: 'Көрсөтүлгөн мезгилде көчүрмө үчүн маалымат жок',
        MANY_STATEMENT: 'Өтүнмө түзүлдү',
      },
    },
    DIALOG: {
      FAIL: 'Көчүрмөнү түзүү мүмкүн болгон жок',
    },
  },
  EXCHANGE_RATES: {
    ALL_RATES: 'Бардык курстар',
    PURCHASE: 'Сатып алуу',
    SALE: 'Сатуу',
    FOR: 'үчүн',
    RATES_LOADING_ERROR: 'Валюта курстары жүктөлгөн жок. Бөлүмдү жаңылап көрүңүз',
    CASH: 'Накталай курстар',
    CASHLESS: 'Накталай эмес курстар',
    CARD: 'Карта боюнча курстар',
    NBKR: 'КРУБ курстары',
    RATES: 'Валюта курсу',
    ALL_EXCHANGE_RATES: 'Бардык валюта курсу',
  },
  SIGNATORIES: {
    MANY_SIGNATORY: 'Кол коючулар',
    PRIMARY_SIGNATURE: '1-чи кол тамга',
    SECONDARY_SIGNATURE: '2-чи кол тамга',
    PROCESSING_SIGNATURE: 'Кол коюлууну күтүүдө',
    ON_VERIFICATION_COMPLETED: 'Кол коюлду',
    PARTIAL_CONFIRMATION_COMPLETED: 'Кол коюлду',
    CANCELED_SIGN_ONE: 'Четке кагылды',
    CANCELED_SIGN_TWO: 'Четке кагылды',
    FOR_EDITING: 'Четке кагылды',
    REVOKE: 'Кайтарып алынды',
    ON_CONFIRMATION_COMPLETED: 'Банкка жиберилди',
  },
  FILTER_HISTORY: {
    FILTER: 'Фильтр',
    SEARCH: 'Издөө',
    PAYMENT_TYPE: 'Төлөм түрү',
    PAYMENT_ORIGIN: 'Келип чыгышы',
    PURPOSE: 'Максатына карай',
    DATE_FROM: 'Датадан баштап',
    DATE_TO: 'Датага чейин',
    AMOUNT_FROM: 'Суммадан баштап',
    AMOUNT_TO: 'Суммага чейин',
    APPLY: 'Колдонуу',
    RESET: 'Жокко чыгаруу',
    WITH: '{value} баштап',
    BEFORE: '{value} чейин',
    RULE_AMOUNT: 'Баштапкы сумма акыркы суммадан ашпашы керек!',
    RULE_THREE_MONTH_PERIOD: '3 айдан ашпаган мөөнөттү көрсөтүңүз',
    ASCENDING: 'Өсүү боюнча',
    DESCENDING: 'Төмөндөө боюнча',
    BY_DEADLINE: 'Мөөнөтү боюнча',
    BY_TOTAL: 'Суммасы боюнча',
    BY_QR_TYPE: 'QR түрү боюнча',
    BY_QR_TRANSACTION_TYPE: 'Транзакция түрү боюнча',
  },
  NOTIFICATION: {
    READ_ALL: 'Баары окулду',
    TITLE: 'Билдирүүлөр',
    EMPTY: 'Азырынча сизде билдирүүлөр жок',
  },
  RECAPTCHA: {
    TEXT: 'Сайт reCAPTCHA жана Googleда корголгон',
    AND: 'жана',
    PRIVACY_POLICY: 'Купуялык саясаттын негизинде',
    TERMS_OF_SERVICE: 'Кызмат көрсөтүү шарттары боюнча',
  },
  ERRORS: {
    AUTH: {
      OTP_INCORRECT: 'TOTP-код туура эмес',
      PERMANENT_LOCKOUT_EXCEPTION: 'Колдонуучу бөгөттөлгөн!',
      USER_CREDENTIALS_EXCEPTION: 'Кардардын IDси же сырсөзү туура эмес',
      PHONE_ALREADY_EXISTS: 'Туура эмес телефон номери',
      USER_STATE_INCORRECT: 'Сиз баштапкы каттоодон өткөн жоксуз. Сыр сөздү өзгөртүү мүмкүн эмес.',
      UNKNOWN: 'Ката! Сураныч, кийинчерээк кайра аракет кылып көрүңүз.',
    },
    PAYMENT: {
      SWIFT_RSBANK_EXCEPTION:
        'Корреспонденттин банкынын ички саясатына байланыштуу тандалган банкка которуу мүмкүн эмес.',
      ACCOUNT_DEBIT_NOT_FOUND: 'Акчаны чыгаруу үчүн эсеп табылган жок.',
      ACCOUNT_CREDIT_NOT_FOUND: 'Алуучунун эсеби табылган жок.',
      OPERATION_NOT_ALLOWED: 'Мындай түрдөгү операция аяктады!',
      ACCOUNT_NOT_ACCESSIBLE: 'Бул эсеп сизге жеткиликтүү эмес!',
      ACCOUNT_DEBIT_CLOSED_OR_SEIZED: 'Каражат чыгаруу эсеби жабык же камакка алынган.',
      ACCOUNT_CREDIT_CLOSED_OR_SEIZED: 'Алуучунун эсеби жабык же камакка алынган.',
      INVALID_OPERATION_TYPE: 'Бул эсеп боюнча операциянын мындай түрүн аткарууга мүмкүн эмес.',
      INSUFFICIENT_FUNDS: 'Эсептеги каражат жетишсиз.',
      CURRENCY_MISMATCH_FOR_CONVERSION:
        'Конвертацияны аткаруу үчүн ар кандай валюталары менен эсепти тандоо талап кылынат.',
      INVALID_PAYMENT_TYPE_FOR_INTERNAL_ACCOUNT: 'Банк ичиндеги эсепке төлөмдүн мындай түрүн колдонуу мүмкүн эмес.',
      CURRENCY_MISMATCH_BETWEEN_ACCOUNTS: 'Эсептен чыгаруу валютасы алуучунун эсебинин валютасы менен дал келбейт.',
      INVALID_OPERATION_FOR_YOUR_COMPANY:
        'Сиздин юридикалык жактын эсебине которуу үчүн операциянын башка түрүн тандаңыз.',
      INVALID_OPERATION_FOR_OTHER_COMPANY:
        'Башка юридикалык жактын эсебине которуу үчүн операциянын башка түрүн тандаңыз.',
      ACCOUNT_NOT_ASSOCIATED_WITH_LEGAL_ENTITY:
        'Эсептен чыгаруу эсебинин алютасы алуучунун эсебинин валютасы менен дал келбейт.',
      BLOCKED_OR_NON_ASSOCIATED_EMPLOYEE: 'Карта эсебине которуу жеткиликтүү эмес.',
      OPERATION_NOT_AVAILABLE_IN_CURRENCY: 'Операциянын бул түрү чет элдик валютада жеткиликтүү эмес.',
      INVALID_REQUISITE_EXCEPTION: 'Карталык эсептин номери боюнча Элкартка которуу мүмкүн эмес',
      INVALID_CARD_TYPE_CODE_EXCEPTION: 'Элкарт Бизнес карталарга которуулар мүмкүн эмес',
      CHECK_RU_CITIZEN_EXCEPTION: 'Банк-корреспонденттин чектөөлөрүнө ылайык, евро менен которуулар жеткиликтүү эмес',
      INVOICE_NOT_FOUND: 'Төлөм эсеби табылган жок',
      WRONG_INVOICE_TYPE: 'Төлөм эсебинин түрү жараксыз',
      WRONG_INVOICE_STATE: 'Төлөм эсебин учурдагы абалында өзгөртүү мүмкүн эмес',
      INVOICE_IS_PAID: 'Төлөм эсеби төлөнгөн. Жокко чыгаруу мүмкүн эмес.',
      CLIENT_NOT_FOUND: 'Кардар табылган жок',
      RECIPIENT_NOT_FOUND: 'Жөнөтүүчү же эсеп номери табылган жок',
      PAYER_EXCEPTION: 'Төлөөчү менен алуучу бирдей боло албайт',
      PAYER_NOT_EMPTY_EXCEPTION: 'Тышкы эсеп үчүн төлөөчү көрсөтүлбөйт',
      ELQR_NOT_CREATED: 'QR түзүү мүмкүн болгон жок',
      WRONG_DETAIL_AMOUNT: 'Товардын суммасы баага жана санга туура келбейт',
      WRONG_AMOUNT: 'Эсептин жалпы суммасы товарлардын суммасына туура келбейт',
      ALREADY_EXISTS_EXCEPTION: 'Мындай аталыштагы товар / кызмат бар',
      OPERATION_NOT_VALID_EXCEPTION: 'Бул эсеп боюнча төлөм мурунтан бар',
      INVALID_INVOICE_STATE: 'Учурдагы статусунда бул эсеп боюнча төлөм түзүүгө болбойт',

      CHECK_FIELD_FOR_NULL_EXCEPTION: 'Төлөмдө кээ бир маалыматтар жок, файлды текшериңиз.',
      FILE_NOT_FOUND_EXCEPTION: 'Бул файл жок.',
      FILE_PREPARE_TO_CREATE_EXCEPTION: 'Түзүүгө даярдануу учурундагы жаңылыштык.',
      FILE_REPEAT_EXCEPTION:
        "Иштетүүнү каталоо учурундагы жаңылыштык:  файлды 'Иштетүү учурундагы жаңылыштык' статусу менен кайталаса болот.",
      FILE_STATE_MISMATCH_EXCEPTION:
        "Төлөмдү түзүү учурундагы жаңылыштык: төлөмдү 'Иштетилди', 'Ийгиликсиз', 'Жүктөө учурундагы жаңылыштык' деген статустар менен файлдан түзсө болот.",
      FILE_SIZE_EXCEPTION: 'Файлдын өлчөмү уруксат берилген мааниден ашып жатат.',
      FILE_EXTENSION_EXCEPTION: 'Файлдын кеңейтилиши күтүлгөнгө шайкеш келбейт.',
      DUPLICATE_PAYMENT_IN_IMPORTED_FILE_EXCEPTION:
        'Файлдагы төлөмдөр кайталанат: маалыматтарды текшергиле/өзгөрткүлө.',
      CANT_DETERMINE_ORGANIZATION_EXCEPTION: 'Ката, банктын бөлүмүнө кайрылуу талап кылынат.',
      DOCUMENT_NUMBER_ALREADY_EXISTS_EXCEPTION:
        'Төлөм тапшырмасынын учурдагы номери колдонулган, уникалдуу номерди колдонууну суранабыз.',
      FORBIDDEN_EXCEPTION: 'Ката, жеткиликтүүлүккө тыюу салынган.',
      NOT_ALLOWED_DELETE_OPERATION: 'Өчүрүү мүмкүн эмес, банкка кат жазуу керек.',
      PROCESS_ALREADY_EXISTS_EXCEPTION: 'Ката. Бул операция иштетүү процессинде.',
      RULE_EXCEPTION: 'Ката. Жазылган маалыматтардын тууралыгын текшергиле.',
      ACTIVITI_PROCESS_ALREADY_EXISTS_EXCEPTION: 'Ката. Мындай төлөм бар.',
      INTRA_AND_INTER_BANK_BIC_CORRESPONDENCE_EXCEPTION:
        'БИК жана эсептердин шайкеш эместиги. (эгер бул транзиттик эсепке которуу болсо, сиздики менен транзиттик эсеп бир бөлүмдөн экенин текшериңиз)',
      INTERBANK_INVALID_CURRENCY_EXCEPTION: 'Клиринг/Гросс үчүн туура эмес валюта.',
      INTERBANK_SAME_BIC_CODES_EXCEPTION: 'Клиринг/Гросс үчүн туура эмес БИК.',
      INTRA_AND_INTERBANK_BBAN_ACCOUNT_STRUCTURE_EXCEPTION:
        'Ката, алуучунун эсебинин структурасы  BBAN га шайкеш келбейт. ',
      INTRA_AND_INTERBANK_SAME_ACCOUNT_EXCEPTION: 'Ката, жөнөтүүчүнүн жана алуучунун коду айырмаланышы керек.',
      INTRABANK_DIFFERENT_BIC_CODES_EXCEPTION: 'Банк ичиндеги төлөм үчүн туура эмес БИК.',
      INVALID_VALUE_DATE_EXCEPTION: 'Ката, өткөн күндөрдү тандоого мүмкүн эмес.',
      NOT_WORKING_DAY_FOR_VALUE_DATE_EXCEPTION: 'Ката, валюталоонун тандалган күнү жумушчу эмес күн болуп саналат.',
      SWIFT_INVALID_EXOTIC_CURRENCY_EXCEPTION: 'Экзотикалык валютада СВИФТ үчүн туура эмес валюта.',
      FILE_READING_EXCEPTION: 'Файлды окуп жатканда ката кетти. Файлдын мазмуну күтүлгөндөй эмес.',

      INVALID_PAYER_BANK_EXCEPTION: 'Төлөөчүнүн банкында БИК табылган жок.',
      INVALID_RECIPIENT_BANK_EXCEPTION: 'Алуучунун банкынан БИК табылган жок.',
      INVALID_PAYMENT_CODE_EXCEPTION: 'Төлөм коду табылган жок.',
      LEGAL_PARTY_ID_CANT_BE_NULL_EXCEPTION: 'Компаниянын Idси жок.',
      PAYER_ACCOUNT_CANT_BE_NULL_EXCEPTION: 'Эсептен чыгаруу эсеби жок.',
      PAYER_BIC_CANT_BE_NULL_EXCEPTION: 'Төлөөчүнүн БИК жок.',
      PAYER_NAME_CANT_BE_NULL_EXCEPTION: 'Төлөөчүнүн аталышы жок.',
      PAYER_AMOUNT_CANT_BE_NULL_EXCEPTION: 'Эсептен чыгаруу суммасы жок',
      PAYER_CURRENCY_CANT_BE_NULL_EXCEPTION: 'Эсептен чыгаруу валютасы туурасында маалыматтар жок.',
      RECIPIENT_ACCOUNT_CANT_BE_NULL_EXCEPTION: 'Эсепке которуу счету жок.',
      RECIPIENT_BIC_CANT_BE_NULL_EXCEPTION: 'Алуучунун  БИК жок.',
      RECIPIENT_NAME_CANT_BE_NULL_EXCEPTION: 'Алуучунун аталышы жок.',
      RECIPIENT_AMOUNT_CANT_BE_NULL_EXCEPTION: 'Эсепке которуу суммасы жок.',
      RECIPIENT_CURRENCY_CANT_BE_NULL_EXCEPTION: 'Эсепке которуу валютасы жок.',
      AMOUNT_CANT_BE_NULL_EXCEPTION: 'Төлөмдүн суммасы жок.',
      CURRENCY_CANT_BE_NULL_EXCEPTION: 'Төлөмдүн валютасы жок.',
      PURPOSE_CANT_BE_NULL_EXCEPTION: 'Төлөмдүн максаты жок.',
      COMMISSION_ACCOUNT_CANT_BE_NULL_EXCEPTION: 'Комиссияны төлөө үчүн счет жок.',
      COMMISSION_CURRENCY_CANT_BE_NULL_EXCEPTION: 'Комиссиянын счетунун валютасы жок.',
      COMMISSION_OPTION_CANT_BE_NULL_EXCEPTION: 'Тарификация туурасында маалыматтар жок.',
      IS_EXOTIC_CANT_BE_NULL_EXCEPTION: 'Экзотиканын суммасы туурасында маалыматтар жок.',
      EXOTIC_AMOUNT_CANT_BE_NULL_EXCEPTION: 'Экзотиканын суммасы туурасында маалыматтар жок.',
      EXOTIC_RATE_CANT_BE_NULL_EXCEPTION: 'Экзотиканын курсу туурасында маалыматтар жок.',
      EXOTIC_CURRENCY_CANT_BE_NULL_EXCEPTION: 'Экзотикалык валюта жок.',
      RUB_CODE_VO_CANT_BE_NULL_EXCEPTION: 'VO коду жок.',
      RUB_INN_CANT_BE_NULL_EXCEPTION: 'KСТИН жок (руб).',
      KZT_BIN_CANT_BE_NULL_EXCEPTION: 'БИН жок.',
      KPP_CANT_BE_NULL_EXCEPTION: 'КПП жок.',
      VALUE_DATE_CANT_BE_NULL_EXCEPTION: 'Валюталоонун күнү жок.',
      OPERATION_CANT_BE_NULL_EXCEPTION: 'Операция жок.',
      PAYER_INN_CANT_BE_NULL_EXCEPTION: 'Төлөөчүнүн СТИНи жок.',
      PAYMENT_CODE_CANT_BE_NULL_EXCEPTION: 'Төлөм коду жок.',
      RUB_CODE_VO_MUST_BE_NULL_EXCEPTION: 'VO коду жок болушу керек.',
      RUB_INN_MUST_BE_NULL_EXCEPTION: 'СТИН (руб) жок болушу керек.',
      KZT_BIN_MUST_BE_NULL_EXCEPTION: 'БИН жок болушу керек.',
      KPP_MUST_BE_NULL_EXCEPTION: 'КПП жок болушу керек.',
      EXOTIC_AMOUNT_MUST_BE_NULL_EXCEPTION: 'Экзотиканын суммасы жок болушу керек.',
      EXOTIC_RATE_MUST_BE_NULL_EXCEPTION: 'Экзотиканын курсу жок болушу керек.',
      EXOTIC_CURRENCY_MUST_BE_NULL_EXCEPTION: 'Экзотикалык валюта жок болушу керек.',
      INSUFFICIENT_FUNDS_EXCEPTION: 'Жеткиликтүү эсеп балансынан төлөм суммасы ашык',

      CELL_VALUE_DATE_IS_EMPTY: 'Датаны тиешелүү уячада көрсөтүңүз.',
      CELL_VALUE_DATE_DATA_IS_INVALID_WORKING_DAY: 'Валюталоо күнү эс алуу күнү болушу мүмкүн эмес.',
      CELL_VALUE_DATE_DATA_IS_INVALID_TIME: 'Уруксат берилген убакыт бүттү, башка күнү аракет кылыңыз.',
      CELL_VALUE_DATE_DATA_IS_INVALID_DATE: 'Валютташтыруунун датасы учурдагы гана болушу керек.',
      CELL_LEGAL_PARTY_ID_IS_EMPTY: '"Компаниянын ID" деген талааны толтуруңуз.',
      CELL_COMPANY_NAME_IS_EMPTY: '"Компаниянын аталышы" деген талааны толтуруңуз.',
      CELL_ACCOUNT_IS_EMPTY: 'Сураныч, тиешелүү ячейкадагы транзиттик эсеп талаасын толтуруңуз.',
      CELL_AMOUNT_IS_EMPTY: '"Жалпы сумма" бош талаасы. ',
      CELL_COMMISSION_IS_EMPTY: '"Банктын комиссиясы" талаасын толтуруңуз.',
      CELL_TOTAL_AMOUNT_IS_EMPTY: '"Корутунду сумма" бош талаасы. ',
      CELL_CURRENCY_IS_EMPTY: '"Валюта" талаасын толтуруңуз.',
      CELL_FORMULA_TOTAL_AMOUNT_IS_EMPTY: '"Эсептелген сумма" бош талаасы.',
      DETAILS_CELL_CARD_ACCOUNT_IS_EMPTY: '"Кызматчынын эсеби" талаасын толтуруңуз.',
      DETAILS_CELL_AMOUNT_IS_EMPTY: 'Сураныч, тиешелүү ячейкадагы кызматкерге которуу суммасы талаасын толтуруңуз.',
      DETAILS_CELL_EMPLOYEE_NAME_IS_EMPTY: '"Кызматчынын аты-жөнү" талаасын толтуруңуз.',
      CELL_VALUE_DATE_INVALID_FORMAT:
        'Дата жөнүндөгү маалымат камтылган уячанын талап кылынган форматы - "Датанын кыска форматы".',
      CELL_LEGAL_PARTY_ID_INVALID_FORMAT:
        'Компаниянын ID жөнүндөгү маалымат камтылган уячанын талап кылынган форматы - "Жалпы/Текст".',
      CELL_COMPANY_NAME_INVALID_FORMAT:
        'Компаниянын аталышы жөнүндөгү маалымат камтылган уячанын талап кылынган форматы - "Жалпы/Текст".',
      CELL_ACCOUNT_INVALID_FORMAT: 'Эсеп жөнүндөгү маалымат камтылган уячанын талап кылынган форматы - "Жалпы/Текст".',
      CELL_AMOUNT_INVALID_FORMAT:
        'Жалпы сумма жөнүндөгү маалымат камтылган уячанын талап кылынган форматы - "Жалпы/Сан".',
      CELL_COMMISSION_INVALID_FORMAT:
        'Банктын комиссиясы жөнүндөгү маалымат камтылган уячанын талап кылынган форматы- "Жалпы/Сан". Ведомость файлындагы суммалардын бөлчөк бөлүгүндөгү сандардын максималдуу саны 2шт.',
      CELL_TOTAL_AMOUNT_INVALID_FORMAT:
        'Корутунду сумма жөнүндөгү маалымат камтылган уячанын талап кылынган форматы - "Жалпы/Сан".',
      CELL_CURRENCY_INVALID_FORMAT:
        'Валюта жөнүндөгү маалымат камтылган уячанын талап кылынган форматы - "Жалпы/Текст".',
      CELL_FORMULA_TOTAL_AMOUNT_INVALID_FORMAT:
        'Эсептелген сумма жөнүндөгү маалымат камтылган уячанын талап кылынган форматы - "Жалпы/Сан".',
      DETAILS_CELL_CARD_ACCOUNT_INVALID_FORMAT:
        'Кызматчынын эсеби жөнүндөгү маалымат камтылган уячанын талап кылынган форматы - "Жалпы/Текст".',
      DETAILS_CELL_AMOUNT_INVALID_FORMAT:
        'Кызматчыга чегерилген сумма жөнүндөгү маалымат камтылган уячанын талап кылынган форматы - "Жалпы/Сан". Ведомость файлындагы суммалардын бөлчөк бөлүгүндөгү сандардын максималдуу саны 2шт.',
      DETAILS_CELL_EMPLOYEE_NAME_INVALID_FORMAT:
        'Кызматчынын аты-жөнү жөнүндөгү маалымат камтылган уячанын талап кылынган форматы - "Жалпы/Текст".',
      CELL_VALUE_DATE_DATA_IS_INVALID: 'Валютташтыруунун датасы учурдагы гана болушу керек.',
      CELL_ACCOUNT_DATA_IS_INVALID:
        'Алыш-бериш эсебинин эсептен чыгаруунун талап кылынган форматы: 16 сан, 109#############',
      CELL_CURRENCY_DATA_IS_INVALID: 'Уруксат берилген валюта: KGS/USD',
      DETAILS_CELL_CARD_ACCOUNT_DATA_IS_INVALID:
        'Кызматчынын карта эсебинин талап кылынган форматы: 16 сан, 109############',
      DETAILS_CELL_AMOUNT_DATA_IS_INVALID: 'Кызматчыга чегерилген сумма терс көрсөткүчтө болушу мүмкүн эмес.',
      DETAILS_LIST_IS_EMPTY: 'Кызматчылардын тизмеси жок.',
      INVALID_SALARY_TOTAL_AMOUNT_SUM:
        '"Карт-эсептерге которуунун суммасы" жана которууга кызматкерлердин тизмесинен эсептелген сумма дал келбейт.',
      INVALID_SALARY_AMOUNT_COMPARISON: '"Карта-эсептерге чегерилген сумма" менен "Эсептелген сумма" дал келбей жатат.',
      INVALID_SALARY_TOTAL_AMOUNT_CALCULATION:
        'Комиссияны кошкондо жалпы сумма туура эмес эсептелди (үлгүдөгу формуланы колдонуңуз).',
      SALARY_DETAIL_DUPLICATE_EXCEPTION: 'Кызматкердин кайталанган эсеби табылды.',
      //FORBIDDEN_EXCEPTION: 'Ведомость ушул уюмга тиешелүү эмес.',
      SALARY_DUPLICATE_EXCEPTION: 'Ушул файлдын аталышы мурда колдонулган.',
      ERROR: 'Эмгек акыга байланыштуу тизме иштелип жатканда, ката кетти. Кайра аракет кылып көрүңүз.',
      SUCCESS: 'Файл ийгиликтүү жүктөлдү.',
      ACCOUNT_ERROR: 'Эсеп табылган жок',
      CURRENCY_ERROR: 'Тандалган валютадагы эсеп табылган жок. Текшерип, кайра аракет кылып көрүңүз.',
      SUM_ERROR: 'Себеп: жыйынтык сумма туура эмес.',
      CONTRACT_NOT_FOUND_ERROR: 'Келишим табылган жок.',
      OPERATION_DATE_ERROR: 'Себеп: күн менен байланышкан операциялык күн аяктады.',
      BALANCE_IS_LESS_AMOUNT_ERROR: 'Эсепте каражат жетишсиз.',
      ACCOUNT_DIFF_ERROR: 'Уюмдун эсеби тизмедеги эсептен айырмаланат.',
      EMPLOYEE_ACCOUNT_ERROR: 'Кызматкердин эсеби жок.',
      EMPLOYEE_CURRENCY_ERROR: 'Кызматчынын эсебиндеги валюта ведомостогу жазууга дал келбейт.',
      FULL_NAME_ERROR: 'Эмгек акы ведомосундагы кызматчынын аты-жөнү  системадагы аты-жөнүнөн айырмаланып жатат.',
      EMPLOYEE_NOT_FOUND: 'Кызматкер келишимде табылган жок',

      EMPLOYEE_STATE_ERROR: 'Кызматкердин статусу туура эмес. Филиалга кайрылыңыз.',
      EMPLOYEE_CARD_STATE_BLOCKED: 'Кызматкердин карта эсеби бөгөттөлгөн. Филиалга кайрылыңыз.',
      EMPLOYEE_CARD_STATE_CLOSED: 'Кызматкердин карта эсеби жабылды. Филиалга кайрылыңыз.',
      EMPLOYEE_CARD_STATE_ERROR: 'Кызматкердин картадагы эсеби менен көйгөйлөр. Филиалга кайрылыңыз.',

      CELL_LEGAL_PARTY_ID_DATA_IS_INVALID:
        'Ката: компаниянын коду туура эмес. Сураныч, киргизилген компаниянын идентификатору туура экенин текшериңиз жана кайра аракет кылыңыз.',
      CLEARING_CREATION_DEADLINE_EXCEPTION:
        'Клирингди түзүү  сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      CLEARING_SIGNING_DEADLINE_EXCEPTION:
        'Клирингге кол коюу сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      GROSS_CREATION_DEADLINE_EXCEPTION:
        'Гросс которууларды түзүү сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      GROSS_SIGNING_DEADLINE_EXCEPTION:
        'Гросс которууларга кол коюу сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      INTRA_OWN_CREATION_DEADLINE_EXCEPTION:
        'Банк ичиндеги өз эсебине которууларды түзүү сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      INTRA_OWN_SIGNING_DEADLINE_EXCEPTION:
        'Банк ичиндеги өз эсебине которууларга кол коюу  сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      INTRA_FOREIGN_CREATION_DEADLINE_EXCEPTION:
        'Банк ичиндеги башка эсептерге которууларды түзүү сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      INTRA_FOREIGN_SIGNING_DEADLINE_EXCEPTION:
        'Банк ичиндеги башка эсептерге которууларга кол коюу  сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      CONVERSION_CREATION_DEADLINE_EXCEPTION:
        'Валюталардын конвертациясын түзүү сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      CONVERSION_SIGNING_DEADLINE_EXCEPTION:
        'Валюталардын конвертациясына  кол коюу сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      SWIFT_CREATION_DEADLINE_EXCEPTION:
        'SWIFT системасы боюнча которууларды түзүү сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      SWIFT_SIGNING_DEADLINE_EXCEPTION:
        'SWIFT системасы боюнча которууларга кол коюу  сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      SALARY_CREATION_DEADLINE_EXCEPTION:
        'Эмгек акыны төлөөнү түзүү сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      SALARY_SIGNING_DEADLINE_EXCEPTION:
        'Эмгек акыны төлөөгө кол коюу  сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      CREATION_DEADLINE_EXCEPTION: 'Операцияны түзүү  сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',
      SIGNING_DEADLINE_EXCEPTION: 'Операцияга кол коюу сессиясы аяктады. Сураныч, валюталоонун башка күнүн тандагыла.',

      ACCOUNT_CREDIT_NOT_FOUND_EXCEPTION: 'Көрсөтүлгөн валютада Алуучунун эсеби табылган жок',
      OPERATION_NOT_ALLOWED_EXCEPTION: 'Тандалган типтеги операцияга көрсөтүлгөн эсеп үчүн тыюу салынат',
      ACCOUNT_NOT_ACCESSIBLE_EXCEPTION: 'Аккаунтту көрүүгө тыюу салынды',
      ACCOUNT_DEBIT_CLOSED_OR_SEIZED_EXCEPTION: 'Эсептен чыгаруу эсеби жок',
      ACCOUNT_CREDIT_CLOSED_OR_SEIZED_EXCEPTION: 'Толуктоо эсеби жеткиликтүү эмес',
      INVALID_OPERATION_TYPE_EXCEPTION: 'Тандалган эсеп боюнча учурдагы операцияны жасоо мүмкүн эмес!',
      CURRENCY_MISMATCH_FOR_CONVERSION_EXCEPTION: 'Эсептерди конвертациялоо үчүн ар кандай валюта болушу керек!',
      INVALID_PAYMENT_TYPE_FOR_INTERNAL_ACCOUNT_EXCEPTION: 'Мүмкүн эмес банк ичиндеги эсептерге төлөм жүргүзүү',
      CURRENCY_MISMATCH_BETWEEN_ACCOUNTS_EXCEPTION:
        'Дебет эсебинин валютасы алуучунун эсебинин валютасы менен бирдей эмес',
      INVALID_OPERATION_FOR_YOUR_COMPANY_EXCEPTION: 'Эсептер бир юрга таандык.түрү',
      ACCOUNT_NOT_ASSOCIATED_WITH_LEGAL_ENTITY_EXCEPTION: 'Алуучунун эсеби берилген юрга тиешелүү эмес.түрү',
      INVALID_OPERATION_FOR_OTHER_COMPANY_EXCEPTION: 'Эсеп-фактуранын тиешеси жок юр. түрү',
      BLOCKED_OR_NON_ASSOCIATED_EMPLOYEE_EXCEPTION: 'Кызматкер эмес же бөгөттөлгөн',
      OPERATION_NOT_AVAILABLE_IN_CURRENCY_EXCEPTION:
        'Тандалган валютада көрсөтүлгөн эсеп боюнча Операция жүргүзүү мүмкүн эмес',

      PACKAGE_TIME_OUT_EXCEPTION: 'Бөлүп төлөөнүн бул түрү жеткиликтүү эмес, QR кодту башка мөөнөткө түзүп көрүңүз',
      PARTNER_DICTIONARY_EXCEPTION:
        'Бул продукт менен өз ара аракеттенүү үчүн керектүү укуктарыңыз жок. Продуктка туташуу үчүн биз менен байланышыңыз.',
      InstallmentForbiddenException:
        'Бул бөлүмдү көрүү же аны менен иштешүү үчүн сизде керектүү укуктар жок. Керектүү уруксаттарды алуу үчүн компанияңыздын уруксаттарды берүү органына кайрылыңыз.',
      ACTIVITY_TIMEOUT_EXCEPTION:
        'Өнөктөш же соода түйүнүнүн активдүү параметрлерин табылган жок, дагы бир жолу аракет кылып көрүңүз',

      USER_HAS_ROLE_EXCEPTION: 'Колдонуучу мурунтан эле бул ролго ээ:',
      USER_EXCEPTION: 'Каттоо эсеби башка телефон номерине байланган',
      EMPTY_PIN_EXCEPTION: 'ПИН/ИНН туура эмес киргизилген: ПИН / ИНН бош болушу мүмкүн эмес',
      WRONG_FIRST_NUM_EXCEPTION: 'ПИН/ИНН туура эмес киргизилген: биринчи цифра 1 же 2 менен башталышы керек',
      WRONG_PIN_DATE_EXCEPTION: 'ПИН/ИНН туура эмес киргизилген: киргизилген маалыматтарды текшерип көрүңүз',
      WRONG_PIN_POSITION: 'ПИН/ИНН туура эмес киргизилген: 9 позициядагы сан 1 жана 5тен турушу мүмкүн эмес',
      TASK_REJECTED_EXCEPTION:
        'ИНН менен бөлүп төлөөчү сатуучуну түзүү үчүн өтүнмө: иштетилип жатат, өтүнмөнүн аягына чейин күтө туруңуз',
      PRODUCT_ROLE_POLICY_EXCEPTION: 'Колдонуучунун бул операция үчүн ролу жок',
      NOT_FOUND_ROLE_EXCEPTION: 'Тилекке каршы роль табылган жок, кийинчерээк аракет кылып көрүңүз',
      DUPLICATE_TASK_EXCEPTION:
        'СТИН: менен бөлүп төлөөчү сатуучуну түзүү үчүн өтүнмө иштетилип жатат, өтүнмө аяктаганга чейин күтө туруңуз',
      CONTRACT_NOT_STARTED_EXCEPTION:
        'Өнөктөш менен келишим баштала элек. Сураныч, түзүлгөн шарттарга ылайык келишим башталганга чейин күтө туруңуз',
      ILLEGAL_ARGUMENT_EXCEPTION: 'Туура эмес номер киргизилген. Сураныч, текшерип, киргизүүнү кайталаңыз',
      LIMIT_BLOCKED_EXCEPTION: 'Компанияңыздын кызматкерлерине гана акча которууга мүмкүн',
      LIMIT_BLOCKED_EXCEPTION_WHITE_LIST:
        'Азырынча кол коюуга жөнөтүү мүмкүн эмес — функция бир аздан кийин жеткиликтүү болот',
      UNSUPPORTED_TYPE_OF_ACCOUNT_FOR_OPERATION_EXCEPTION: 'Элкарт жана талап эсептерине кайтаруу азырынча жеткиликсиз',
      NOT_FOUND: '@:SHARED.RULE.CLIENT_NOT_FOUND',
      UNKNOWN: 'Ката! Кийинчерээк аракет кылып көрүңүз!',
      KNOWN: 'Ката. Кийинчерээк аракет кылып көрүңүз.',
    },

    OFFLINE: 'Интернет байланышы жок',
    DOCUMENT_TEMPLATE: {
      FORBIDDEN_EXCEPTION: 'Кирүүгө тыюу салынган',
      LARGE_DOC_NOT_FOUND_EXCEPTION: 'Файл табылган жок',
      LARGE_DOC_ALREADY_EXISTS_EXCEPTION: 'Көрсөтүлгөн параметрлери бар документ бар',
      LARGE_DOC_DOWNLOAD_NOT_ALLOWED_EXCEPTION: 'Файлды жүктөө мүмкүн эмес, анткени ал "Даяр" статусуна ээ эмес',
      NOT_FOUND_QR_PAYMENT: 'Тандалган мезгил үчүн маалыматтар жок \n  Даталарды өзгөртүп, кайра аракет кылыңыз',
      UNKNOWN: 'Ката! Дагы бир аракет кылып көрүңүз',
    },
    PAY_LOGIC: {
      ACTION_ERROR: 'Аракетти аткарууда ката кетти. Сураныч, дагы аракет кылыңыз.',
      NOT_FOUND:
        'Суралган маалыматтар табылган жок. Сураныч, киргизилген маалыматтарды текшерип, кайрадан аракет кылыңыз.',
      NO_DEBTS: 'Карыздар жок. Бардык эсептер төлөнгөн.',
      PROVIDER_ANSWER_ERROR: 'Кызмат көрсөтүүчүнүн жообунда ката кетти. Сураныч, кийинчерээк кайра аракет кылыңыз.',
      SERVICE_BLOCKED_ERROR: 'Кызмат бөгөттөлгөн. Көбүрөөк маалымат алуу үчүн колдоо бөлүмүнө кайрылыңыз.',
      SERVICE_ERROR: 'Кызматта ката кетти. Сураныч, кийинчерээк кайра аракет кылыңыз.',
      SYSTEM_ERROR: 'Системалык ката кетти. Сураныч, кийинчерээк кайра аракет кылыңыз.',
      VALIDATION_ERROR:
        'Маалыматтарды текшерүү катасы. Сураныч, киргизилген маалыматтарды текшерип, кайрадан аракет кылыңыз.',
      UNKNOWN: 'Ката! Дагы бир аракет кылып көрүңүз',
    },
    OUTLET: {
      UNKNOWN: 'Ката! Дагы бир аракет кылып көрүңүз',
      KNOWN: 'Ката! Дагы бир аракет кылып көрүңүз',
      CASHIER_HAS_ACTIVE_SHIFT_EXCEPTION: 'Кассирдин нөөмөтү {salePointName} сатуу түйүнүндө {cashCode} ачык',
      CASHIER_HAS_ACTIVE_SHIFT_EXCEPTION_HINT: 'Кассирди чыгарып салуу үчүн сменаны жабууну сураныңыз',
      DUPLICATE_SALE_POINT_NAME_EXCEPTION: 'Мындай аталыштагы түйүн бар',
      ACCOUNT_SAVING_EXCEPTION: 'Эсепти сактоо мүмкүн болгон жок. Кайра аракет кылыңыз',
      ACCOUNT_SAVING_IN_ACQUIRING_EXCEPTION: 'Эсепти сактоо мүмкүн болгон жок. Кайра аракет кылыңыз',
      CASHIER_HAS_OPEN_SHIFT_EXCEPTION: 'Кассирдин сменасы ачык. Улантуу үчүн аны жабыңыз',
      ENTITY_NOT_FOUND_EXCEPTION: 'Маалымат табылган жок, дагы аракет кылыңыз',
      FILE_NOT_FOUND_EXCEPTION: 'Маалымат табылган жок, дагы аракет кылыңыз',
      SALE_POINT_EDIT_FORBIDDEN_EXCEPTION:
        'Түйүндө ККМ-касса бар. Маалыматты өзгөртүү үчүн адегенде ККМ-кассаны өчүрүңүз',
      TAX_ATTRIBUTE_SAVING_EXCEPTION: 'Улантуу үчүн салык бөлүмүн жана түйүндүн координаттарын көрсөтүңүз',
    },
    STATEMENT: {
      PERIOD_IS_LIMITED_BY_1_YEAR: 'Выписканын жүктөө мөөнөтүнүн максималдуу аралыгы — 1 жыл',
      UNKNOWN: 'Эсеп көчүрмөсүн түзүү мүмкүн болгон жок',
    },
  },
  LOAN_CLAIMS: {
    TITLE: 'Насыялар',
    SOON: 'Насыялар жакында пайда болот',
  },
  QR_CODE: {
    CREATE_QR: 'QR-код тузүү',
    MY_QR_CODE: 'Менин QR-кодум',
    RECEIVING_FUNDS: 'Каалаган банктан төлөмдөрдү кабыл алуу',
    TITLE: 'QR-код',
    SELECT_ACCOUNT: 'Чегерүү эсеби',
    COMMISSION: 'Төлөмдү кабыл алуу үчүн комиссия 0,2%',
    DOWNLOAD: 'QR көчүрүү',
    PRINT: 'QR басып чыгаруу',
    BLACK_AND_WHITE_A4: 'ак-кара А4',
    BLACK_AND_WHITE_A5_A6: 'ак-кара А5, А6',
    COLOR_A4: 'түстүү А4',
    COLOR_A5_A6: 'түстүү А5, А6',
    SAVE_CHANCE: 'өзгөртүүлөрдү сактоо',
    CANCEL_CHANCE: 'өзгөртүүлөрдү жокко чыгаруу',
    EMPTY_CARD: 'Эсептер жана карталар жок',
    OPEN_ACCOUNT_CARD: 'Optima Bankтын бөлүмүндө эсептешүү эсебин же Visa Business ачыңыз',
    SHARE: 'Бөлүшүү',
    CARD_ACCOUNTS: 'Карталык эсептер',
    SETTLEMENT_ACCOUNTS: 'Эсептешүү эсептер',
    NO_ACCESS_ACCOUNT: 'Эсепке кирүү мүмкүнчүлүгү жок',
    GET_ACCESS: 'Кирүү укугун алуу үчүн жетекчиликке кайрылыңыз',
    NO_CARD: 'Карталар жок',
    OPEN_CARD: 'Кирүү укугун алуу үчүн жетекчиликке кайрылыңыз',
    FORBIDDEN: 'Нет доступа к счёту зачисления точки',
    GET_ACCESS_SALE: 'Кирүү укугун алуу үчүн компаниянын ээсине кайрылыңыз',
    OPEN_ACCESS:
      'Откройте доступ к счёту: «Настройки» → «Пользователи» → Выберите сотрудника → Выберите расчётный счёт → Включите «Создание QR»',
    ON_ACCOUNT: 'Эсепке',
    ON_SALE_POINT: 'Сатуу түйүнгө',
    EMPTY_SALE_POINT: 'QR-код түзүү үчүн сатуу түйүнүн кошуңуз',
    ASK_SALE_POINT: 'QR-код түзүү үчүн жетекчиңизге соода түйүнүн кошуу керектигин айтыңыз',
    TAB_SALE_POINT: 'Түйүн үчүн QR',
    TAB_PERSONAL: 'Жеке QR',
    PURPOSE: 'Багыты',
    PURPOSE_HINT: 'Багытына төлөм кимге же эмнеге жиберилгенин көрсөтсөңүз болот',
    ALLOW_EDIT_AMOUNT: 'Сумманы өзгөртүүгө уруксат берүү',
    ALLOW_EDIT_AMOUNT_HINT: 'Күйгүзгөндө төлөөчү сиз көрсөткөн сумманы өзгөртө алат',
    WITH_PURPOSE_TITLE: 'Багыты жана көрсөтүлгөн\n суммасы бар QR',
    WITH_PURPOSE_SUBTITLE: 'Ар бир кардар же кызмат\n үчүн жеке QR-код түзүңүз',
    WITH_PURPOSE_ITEM_TITLE: 'Төлөмдүн багыты',
    WITH_PURPOSE_ITEM_TEXT:
      'Сиз кардар үчүн төлөмдүн багытын көрсөтүп QR-код түзөсүз — эмне үчүн, ким үчүн жана канча суммага',
    NO_MANUAL_INPUT_TITLE: 'Кол менен киргизбестен төлөө',
    NO_MANUAL_INPUT_TEXT: 'Кардар QR-кодду сканерлейт жана төлөм автоматтык түрдө түзүлөт',
    HISTORY_TITLE: 'Төлөмдөрдүн таржымалы',
    HISTORY_TEXT:
      'Төлөмдөрдүн таржымалында сиз көрсөткөн багыт көрүнөт жана каражат эмне үчүн которулганын түшүнүүгө болот',
    WHAT_IS_PERSONAL_QR: 'Жеке QR деген эмне?',
  },
  CARD: {
    TITLE: 'Карталар',
    BLOCK: 'Картаны бөгөттөө',
    SETTINGS: 'Орнотуулар',
    HISTORY: 'Тарых',
    LIMIT: 'Чектөөлөр',
    LIMIT_TITLE: 'Чектөө түрүн тандаңыз',
    BLOCK_PAYMENT_CARD: 'Сиз төлөм картасы тосмолоп жатасыз',
    ARRESTED: 'Бөгөттөн чыгаруу',
    FINAL_ARRESTED: 'Бөгөттөлгөн',
    AVAILABLE_BALANCE: 'Жеткиликтүү баланс',
    RULE: 'Карталар боюнча бардык чектөөлөрдүн максималдуу суммасы 5 000 000,00 сомдон ашпоого тийиш.\nБашка чектерди карап чыгыңыз.',
    EMPTY_CARD: 'Жеткиликтүү карталар жок',
    EMPTY: 'Көрсөтүлгөн мезгил үчүн маалыматтар жок',
    YOUR_CARD_IS_BLOCKED: 'Сиздин картаңыз бөгөттөлдү',
    YOUR_CARD_IS_BLOCKED_DESCRIPTION: 'Бөгөттөн чыгаруу үчүн Optima Bankтын кеңсесине кайрылыңыз.',
    COMMISSION: 'Комиссиясы',
    FILTER_HINT: '13.02.2025 чейин болгон күндөр үчүн көчүрмө алуу үчүн филиалга кайрылыңыз.',
    INFORMATION: {
      CARD_ACCOUNT: 'Карталык эсеп',
      ALL: 'Баары',
      REPLENISHMENT: 'Толтуруу',
      FILTER: 'Фильтр',
      WRITE_OFF: 'Эсептен чыгаруу',
      SET: 'Колдонуу',
      THREE: '3 күндүн ичинде',
      WEEK: 'Жума ичинде',
      MONTH: '30 күндүн ичинде',
      TOTAL_RECEIPTS: 'Келип түшүүлөрдүн жыйынтыгы',
      TOTAL_WRITE_OFF: 'Эсептен чыгаруулардын бардыгы',
      PERIOD_START_BALANCE: 'Мезгил башындагы калдыгы',
      PERIOD_END_BALANCE: 'Мезгил аягындагы калдыгы',
    },
    BLOCK_CARD: {
      LOSS: 'Картаны жоготуу',
      THEFT: 'Картаны уурдатуу',
      COMPROMISING: 'Картаны компрометациялоо',
      TEMPORARY: 'Убактылуу бөгөттөө',
      TEXT: 'Бөгөттөлгөндөн кийин карта операцияларды жүргүзүү үчүн жеткиликсиз болот. Картаны Банктын бөлүмдөрүндө бөгөттөн чыгарууга болот. Карта жоголгон учурда же маалыматтардын чыгып кетишине шек жаралса, картаны кайра чыгарууну сунуштайбыз.',
      BLOCK: 'Картаны бөгөттөө',
    },
    RENAME: {
      RENAME_CARD: 'Картанын атын өзгөртүү',
      NAME_CARD: 'Картанын аталышы',
      SET_NAME: 'Атын өзгөртүү',
      DESIRED_NAME: 'Каалаган карта атын киргизиңиз',
      SUCCESS: 'Картанын аталышы ийигиликтүү өзгөртүлдү',
    },

    SHARED: {
      SET: 'Орнотуу',
      RESET: 'Жоготуу',
      LIMIT_IN_DAY: 'Суткадагы лимит (сомах)',
      DATE_TO: 'Аяктоо датасы',
      DATE_FROM: 'Башталыш датасы',
      AVAILABLE_AMOUNT: 'Жеткиликтүү сумма',
      AVAILABLE_AMOUNT_TRANSACTION: 'Транзакциялардын жеткиликтүү саны',
      AVAILABLE_AMOUNT_TRANSACTION_IN_DAY: 'Транзакциялардын саны (суткасына)',
      AVAILABLE_OUT_OF: 'Жеткиликтүү {available} ичинен {outOf}',
      MAIN_BALANCE: 'Негизги калдык',
      CARD_ACCOUNT: 'Карталык эсеп',
      CARD: 'Карта',
      NOT_HAVE_CARD_ACCOUNT: 'Сизди карталык эсеп жок',
    },

    CASH_LIMIT: 'Банкоматта жана POS-терминалдарда накаталай акча алуу',
    RETAIL_CARD_PRESENT: 'POS-терминалдар аркылуу накталай эмес сатып алуулар',
    CARD_NOT_PRESENT: 'Интернет аркылуу сатып алуулар/төлөмдөр',
    ONLINE_PAYMENTS: 'Интернет төлөмдөр',
    FUNCTIONALITY_NOT_APPLY_RECURRING_PAYMENT: 'Бул функция кайталануучу төлөмдөргө таасир этпейт',
    OPERATION_ALLOWED: 'Операцияларга уруксат берилди',

    DIALOG: {
      LIMIT: {
        SETTING: 'Чектөө коюу...',
        SUCCESS: 'Чек ийгиликтүү орнотулду',
        ERROR: 'Ката, кийинчерээк аракет кылып көрүңүз',
      },
      BLOCK: {
        SETTING: 'Кулпуну орнотуу...',
        SUCCESS: 'Кулпу ийгиликтүү орнотулду',
        ERROR: 'Ката, кийинчерээк байкап көрүңүз',
      },
      UNLOCK: {
        SETTING: 'Картанын кулпусун ачуу...',
        SUCCESS: 'Картанын кулпусу ийгиликтүү ачылды',
        ERROR: 'Ката, кийинчерээк байкап көрүңүз',
      },
    },

    SETTINGS_USER: {
      VIEW_CARD: 'Картаны кароо',
      BLOCK: 'Блокко салуу/блоктон чыгаруу',
      LIMITS: 'Лимиттерди орнотуу',
      DETAILS: 'Лимиттерди кароо',
      SUCCESS: 'Картаны орнотуулары өзгөртүлдү',
      VIEW_ACCOUNT: 'Карталык эсепти көрүү',
      CARD_ACCOUNTS: 'Карталык эсептер',
      NOTIFICATION_QR: 'QR которуулар үчүн эскертмелерди басыңыз',
      GENERATE_QR: 'QR түзүү',
    },
  },
  POS: {
    STATEMENT: 'POS боюнча көчүрмөлөр',
    TITLE: 'POS-терминалдар',
    BANNER: {
      TITLE: 'Терминал заказ кылыңыз',
      LABEL: 'Optima жана Элкарт карталары боюнча {value}% комиссия',
    },
    DIALOG: {
      CONFIRM_CLOSE: {
        TITLE: 'Чыккыңыз келеби?',
        LABEL: 'Өтүнмөнүн черновиги сакталып калбайт',
      },
    },
    QUESTIONS: {
      TERMINALS_COUNTS: 'Канча терминалга заказ кылгыңыз келет?',
      ACCOUNT: 'Сатуудан түшкөн акчаны кайда которуу керек?',
      ADDRESS: 'Терминалды кайда коюу керек?',
      USER: 'Түйүн үчүн ким жооп берет?',
      WORKING_DAYS: 'Качан иштейсиз?',
    },
    ONBOARDING: {
      TERMINAL: {
        HEADER: 'Төлөмдү карта жана  QR код боюнча кабыл алыңыз',
        SUB_HEADER: 'Терминал Visa, Mastercard, UnionPay жана Элкарт менен иштейт',
        COMMISSION: '{value}% комиссия',
        COMMISSION_HINT: 'Optima карталары жана Элкарт системалары боюнча',
        CARD_HINT: 'Башка банктардын жана системалардын карталары боюнча',
        DELIVERY: 'Тез жеткирүү',
        DELIVERY_HINT: 'Үч күндүн ичинде',
        FLEX_COMMISSION: 'Төлөмдөрдү кабыл алууда ийкемдүү комиссиялар',
        ABOUT_TARIFF: 'Тарифтер тууралуу кеңири маалымат',
      },
      PHOTO: {
        HEADER: 'Өтүнмө үчүн эки сүрөт түйүн даярдаңыз',
        SUB_HEADER: 'Өтүнмөгө тиркөө үчүн эртерээк сүрөт тартып алыңыз',
        EXPECTATION: 'Сүрөттөн эмнени күтөбүз',
        OUTSIDE: 'Сыртынан',
        OUTSIDE_HINT: 'Жарнама жана кире бериш көрүнүп турат',
        INSIDE: 'Ичинен',
        INSIDE_HINT: 'Текчелер жана имараттын ичи көрүнүп турат',
      },
      AGREEMENT: {
        LABEL: 'Тапшырыкты тариздөө" баскычын басуу менен, сиз',
        LINK: 'келишимдин шарттарына макулсуз',
      },
    },
    ORDER: {
      TITLE: 'Терминалга өтүнмө | Терминалга өтүнмөлөр',
      SUB_TITLE: 'Терминал заказ кылуу',
      APPLICATION: 'Өтүнмө | Өтүнмөлө',
      SUBMIT_APPLICATION: 'Өтүнмөнү тариздөө',
      ADD_KKM: 'Заказга кассалык аппаратты (ККМ) кошуу',
      ENROLLMENT_ACCOUNT: 'Эсепке которуу эсеби',
      STORE_NAME: 'Түйүндүн аталышы',
      OFFER_TYPES: 'Сиздин товарлар же кызматтар',
      HAS_SECURITY: 'Түйүндө камералар же күзөтчүлөр барбы',
      FRONT_PHOTO: 'Түйүндүн сырттан тартылган сүрөтүн жүктөңүз',
      FRONT_PHOTO_DOWNLOADED: 'Түйүндүн сырттан тартылган сүрөтү жүктөлдү',
      BACK_PHOTO: 'Түйүндүн ичинен тартылган сүрөтүн жүктөңүз',
      BACK_PHOTO_DOWNLOADED: 'Түйүндүн ичинен тартылган сүрөтү жүктөлдү',
      WORKING_DAYS_HINT: 'Графикти көрсөтүү үчүн жуманын бир күнүн же бир нече күнүн бөлүп көрсөтүңүз',
      OPENING: 'Ачылышы',
      CLOSING: 'Жабылышы',
      ADD_SCHEDULE: 'Расписание кошуу',
      DELETE_SCHEDULE: 'Расписаниени алып салуу',
      SUBMIT: 'Өтүнмөнү жөнөтүү',
      SENT_TO_REVIEW: 'Кароого жөнөтүлдү',
      SENT_HINT: 'Статусун "Өтүнмөлөр" бөлүмүнөн байкоого болот',
      TO_APPLICATIONS: 'Өтүнмөлөргө',
    },
    ABOUT_KKM: {
      TITLE: 'Кассалык аппарат деген эмне?',
      SUB_TITLE: 'Кассалык аппарат же ККМ',
      LI_1: 'сатуунун эсебин жүргүзүүгө жардам берет',
      LI_2: 'фискалдык чектерди чыгарат',
      LI_3: 'маалыматтарды салык кызматына өзү өткөрүп берет',
      FOOTER: 'Өзүңүздөн ашыкча бюрократияны  алып салуу үчүн тапшырыкка ККМ кошуңуз',
    },
    RULE: {
      INVALID_PHOTO_EXTENSION:
        'Тыюу салынган түрдөгү файл бекитилген. Файлдын уруксат берилген түрлөрү: .heic .png .jpeg\nСураныч, жүктөлгөн файлды өчүрүңүз жана уруксат берилген түрдөгү файлды жүктөңүз',
      FILE_LARGE_ERROR:
        'Сиз тараптан бекитилген файлдын өлчөмү максималдык кабыл алынган 5 мегабайт өлчөмдөн көп.\nСураныч, жүктөлгөн файлды өчүрүңүз жана уруксат берилген түрдөгү файлды жүктөңүз',
    },
    STATUS: {
      COMPLETED: 'Жактырылды',
      IN_PROCESS: 'Карап жатабыз',
      REJECTED: 'Четке кагылды',
      REJECT_REASON: 'Четке кагуунун себеби',
    },
    TASKS: {
      TITLE: 'Өтүнмөлөр',
      STORE_NAME: 'Сатуу түйүнү',
      TERMINALS_COUNT: 'Терминалдардын саны',
      CREATE_DATE: 'Өтүнмөнүн датасы',
      ERROR: 'Өтүнмөлөрду алуу мүмкүн эмес',
    },
    DETAILS: {
      TERMINALS: 'Терминалдар',
      TO_ORDER: 'Заказга',
      KKM: 'Кассалык аппарат (ККМ)',
      PLACE: 'Точка',
      NAME: 'Аты',
      OFFER_TYPES: 'Товарлар же кызматтар',
      RESPONSIBLE_PERSON: 'Жооптуу адам',
      WORK_SCHEDULE: 'Жумуш убактысы',
      ERROR: 'Тиркемелени кабыл алуу мүмкүн эмес',
    },
  },
  SALARY: {
    ONBOARDING: {
      TITLE: 'Төлөмдөрдү банкка ишенип тапшырыңыз: комиссиядан үнөмдөңүз жана рутинди унутуңуз.',
      CONNECT: 'Кошулуу',
      FEE_FREE: { TITLE: '0% Комиссия', DESCRIPTION: 'Кызматкерлерге которуулар - таптакыр акысыз.' },
      INSTANT_CREDIT: {
        TITLE: 'Дароо чегерүү',
        DESCRIPTION: 'Ведомостко кол коюлгандан кийин акча дароо карталарга түшөт.',
      },
      SUPPORT: { TITLE: 'Ишенимдүү колдоо', DESCRIPTION: 'Толук коштоону камсыз кылабыз.' },
      ANYTIME: { TITLE: '24/7 чегерүү', DESCRIPTION: 'Ведомостту каалаган убакта, дайыма жөнөтө аласыз.' },
      STEP_TWO: {
        TITLE: 'Эсептешүү эсебин ачкан банк офисине кайрылыңыз',
        SUBTITLE:
          'Айлык акы долбооруна кошулуу аз убакытты алат. Кошулгандан кийин сиз Optima Business аркылуу кызматкерлерге эмгек акыны ыңгайлуу чегере аласыз.',
        ADDRESS_LABEL: 'Банк офисинин дареги',
        IMPORTANT: 'Маанилүү! Өзүңүз менен паспортту жана компаниянын керектүү документтерин алып барыңыз.',
      },
    },
    BANNER: {
      TITLE: 'Айлык акынын эсептешүү эсептен которуңуз',
      INFO: 'Сайтта ведомостторду түзүңүз, транзиттик эсепке алдын ала которууларсыз жана Excel таблицаларсыз',
    },
    DELETE_ALL: 'Баарын өчүрүү',
    LOADING_CHANGE_SETTINGS: 'Жүктөлүүдө...',
    SUM: 'Суммасы',
    TOTAL: 'Бардыгы',
    WITHDRAWAL_ACCOUNT: 'Эсептен чыгаруу эсеби',
    CODE_COMPANY: 'Компаниянын коду',
    NAME_COMPANY: 'Компаниянын аталышы',
    ACCOUNT_NUMBER: 'Эсептешүү эсебинин номери',
    AMOUNT_CREDIT: 'Карталык эсептерге которулган сумма',
    SELECT_TEMPLATE: 'Шаблондордон тандоо',
    CREATE_SALARY: 'Ведомосту түзүү',
    UPLOAD_TEMPLATE: 'Excel-ведомосту жүктөө',
    EMPLOYEES: 'Кызматкерлер',
    IN_REVIEW: 'Текшерүүдө',
    TO_STATEMENTS: 'Ведомосттордун тизмесине',
    CREDITED_AMOUNT: 'Которуулардын суммасы',
    SEND_STATEMENT: 'Текшерүүгө жөнөтүү',
    ADD_STATEMENT: 'Ведомосту кошуу',
    DOWNLOAD_TEMPLATE: 'Excel-шаблонду жүктөө',
    SELECTED_EMPLOYEE: 'Кызматкерлери тандалды',
    ID_COMPANY: 'Компаниянын ID`сы',
    TRANSFER_ACCOUNT: 'Которуу эсеби',
    SELECT_ALL: 'Баарын тандоо',
    ADD_EMPLOYEE: 'Кызматкерди кошуу',
    ADD_TEMPLATE: 'Шаблонго кошуу',
    AMOUNT_COMMISSION: 'Комиссия суммасы',
    TOTAL_SUM: 'Жыйынтык сумма',
    COMPANY_NAME: 'Компаниянын аталышы',
    TRANSIT: 'Транзиттик эсеп',
    RKO: 'Эсептешүү эсеби',
    STATEMENT_NAME: 'Ведомосттун аталышы',
    NOT_CONNECTED_SALARY: 'Айлык акы долбоору кошулган эмес',
    IMPORT: 'Ведомостту жүктөө',
    CAUSE: 'Себеби',
    TOTAL_AMOUNT: 'Жыйынтык сумма',
    BACK_TO_SALARY: 'Айлык акы долбооруна кайтып келүү',
    DELETE_STATEMENT: 'Ведомость өчүрүлдү',
    DELETING_STATEMENT: 'Ведомость өчүрүлүп жатат...',
    INFO: {
      TITTLE:
        'Ведомостту жүктөөдөн кызматкерлерге каражаттарды чегерүүгө чейинки бардык жол төмөнкү кадамдардан турат:',
      SUB_TITTLE:
        '1) Туура толтурулган ведомостту жүктөө. Бекитилген шаблонду колдонуу маанилүү!\n2) Андан ары ведомость 1-этапка туура келет, анда система ведомосттун туура толтурулгандыгын, кызматкерлердин карталарынын активдүүлүгүн жана эсептеги калдыктарды автоматтык түрдө текшерет.\n3) 1-этапта "иштетилди" статусун алганда, ведомость "кол коюуга даяр" статус менен 2-этапка туура келет, андан кийин аны саат 17:00гө чейин кол коюуга жөнөтүү жана 17:25ке чейин кол коюу керек. "Аякталды" статусу кызматкерлерге акча каражаты чегерилгендигин билдирет.',
    },
    MORE_DETAILS: 'Кененирээк',
    TITLE: 'Айлык акы долбоору',
    ATTACHED_FILE: 'Бекитилген файл',
    PAY_CONTROL_NOT_AVAILABLE: 'Ведомостту кол коюуга жөнөтүү мүмкүн эмес. Кол койгондордун биринде  PayControl жок.',
    TABS: {
      EMPLOYEE: 'Кызматкерлер',
      STATEMENT: 'Ведомость',
    },
    FAQ: {
      TITLE: 'FAQ — Эмгек акы долбоору',
      VIDEO: 'Видеонускаманы көрүү',
      TOPICS: {
        CREATE: {
          TITLE: 'Эмгек акы ведомостун түзүү',
          WHEN: {
            TITLE: 'Качан колдонуу керек',
            TEXT: 'Эгер кызматкерлерге эмгек акы ведомостун кол менен түзүп, жөнөтүү зарыл болсо.',
          },
          STEPS: {
            TITLE: 'Иш-аракеттердин тартиби',
            ITEM: {
              1: '«Эмгек акы долбоору» → «Ведомосттор» бөлүмүнө өтүңүз.',
              2: '«Ведомость кошуу» → «Ведомость түзүү» баскычтарын басыңыз.',
              3: 'Акча каражаттары чыгарыла турган эсепти тандаңыз.',
              4: 'Кызматкерлерди кошуп, төлөнүүчү суммаларды көрсөтүңүз.',
              5: 'Толтурулгандан кийин ведомость «Кол коюуга даяр» статусуна ээ болот.',
              6: 'Ведомостту ачып, «Кол коюуга» баскычын басыңыз.',
              7: '«Кол коюуга төлөмдөр» бөлүмүнө өтүңүз.',
              8: 'Ведомостту тандап, «Кол коюу» баскычын басыңыз.',
            },
          },
          EXTRA: {
            TITLE: 'Кошумча мүмкүнчүлүктөр',
            ITEM: {
              1: 'Ведомость аяктагандан кийин банктын мөөрү коюлган PDF-документти жүктөөгө болот.',
              2: 'Туруктуу төлөмдөрдү жүргүзүү үчүн «Кайталоо» баскычын колдонуңуз — система мурунку ведомосттон кызматкерлерди жана суммаларды автоматтык түрдө толтурат.',
            },
          },
        },
        EXCEL: {
          TITLE: 'Эмгек акы ведомостун Excel аркылуу жүктөө',
          NOTICE:
            'Маанилүү! Эгер ведомость «Баш тартуу» статусун алса, Excel-шаблондун туура толтурулганын текшерип, кайра жүктөңүз.',
          WHEN: {
            TITLE: 'Качан колдонуу керек',
            TEXT: 'Кызматкерлер тууралуу маалыматтарды Excel файлынан массалык түрдө жүктөө керек болсо.',
          },
          STEPS: {
            TITLE: 'Иш-аракеттердин тартиби',
            ITEM: {
              1: '«Эмгек акы долбоору» → «Ведомосттор» бөлүмүнө өтүңүз.',
              2: '«Excel-шаблонду жүктөө» баскычын басыңыз.',
              3: 'Кызматкерлердин маалыматтарын шаблонго толтуруңуз.',
              4: 'Файлды түзмөгүңүзгө сактаңыз.',
              5: '«Ведомость жүктөө» баскычын басыңыз.',
              6: 'Толтурулган Excel-файлды тандаңыз.',
              7: 'Жүктөө ийгиликтүү аяктагандан кийин ведомость «Кол коюуга даяр» статусуна ээ болот.',
              8: 'Ведомостту ачып, «Кол коюуга» баскычын басыңыз.',
              9: '«Кол коюуга төлөмдөр» бөлүмүнө өтүңүз.',
              10: 'Ведомостту тандап, «Кол коюу» баскычын басыңыз.',
            },
          },
          REQUIREMENTS: {
            TITLE: 'Excel-шаблонго коюлган талаптар',
            ITEM: {
              1: 'Файлдын форматталышын өзгөртпөңүз.',
              2: 'Формулаларды өчүрбөңүз.',
              3: 'Бош саптарды калтырбаңыз.',
              4: 'Шаблондун түзүмүн сактаңыз.',
            },
          },
          EXTRA: {
            TITLE: 'Кошумча мүмкүнчүлүктөр',
            ITEM: {
              1: 'Ведомость аяктагандан кийин банктын мөөрү коюлган PDF-документти жүктөөгө болот.',
              2: 'Туруктуу төлөмдөрдү жүргүзүү үчүн «Кайталоо» баскычын колдонуңуз.',
            },
          },
        },
        CONNECT_EMPLOYEE: {
          TITLE: 'Кызматкерди эмгек акы долбооруна туташтыруу',
          NOTICE:
            'Маанилүү! Туташтыруудан мурун кызматкер системага кошулганын жана керектүү жеткиликтүүлүк укуктарына ээ экенин текшериңиз.',
          WHEN: {
            TITLE: 'Качан колдонуу керек',
            TEXT: 'Кызматкерге эмгек акы долбооруна жеткиликтүүлүк берүү зарыл болсо.',
          },
          STEPS: {
            TITLE: 'Иш-аракеттердин тартиби',
            ITEM: {
              1: '«Жөндөөлөр» → «Колдонуучулар» бөлүмүнө өтүңүз.',
              2: 'Кызматкерди тандаңыз.',
              3: '«Эмгек акы долбоору» которгучун активдештириңиз.',
            },
          },
          RESULT: {
            TITLE: 'Натыйжа',
            ITEM: {
              1: 'Кызматкер туташтырылгандан кийин ага эмгек акы долбоорунун алкагында эсептик эсеп жеткиликтүү болот.',
              2: 'Которгуч өчүрүлгөндө эмгек акы долбооруна жеткиликтүүлүк жабылат.',
            },
          },
        },
        ERRORS: {
          TITLE: 'Эмгек акы ведомостундагы каталар',
          NOTICE:
            'Сунуш. Кайра жөнөтүүдөн мурун кызматкерлердин маалыматтарынын, төлөнүүчү суммалардын жана тандалган акча каражаттары чыгарыла турган эсептин тууралыгын текшериңиз.',
          WHEN: {
            TITLE: 'Качан колдонуу керек',
            TEXT: 'Эгер ведомость четке кагылган же иштетүүдөн өтпөй калган болсо.',
          },
          REASONS: {
            TITLE: 'Мүмкүн болгон каталар',
            ITEM: {
              1: {
                TERM: 'Кол коюучу тарабынан четке кагылды',
                TEXT: 'Документ кол коюу этабында четке кагылды.',
              },
              2: {
                TERM: 'Кол коюу мөөнөтү өтүп кетти',
                TEXT: 'Документ кол коюуну күтүп, өтө узак убакыт турду.',
              },
              3: {
                TERM: 'Текшерүүдөн өткөн жок',
                TEXT: 'Ведомосттон каталар же туура эмес маалыматтар аныкталды.',
              },
              4: {
                TERM: 'Банк тарабынан четке кагылды',
                TEXT: 'Документ банк тарабынан иштетүүдөн өткөн жок.',
              },
            },
          },
          RETRY: {
            TITLE: 'Ведомостту кайра жөнөтүү',
            ITEM: {
              1: 'Катасы бар ведомостту ачыңыз.',
              2: '«Кайталоо» баскычын басыңыз.',
              3: 'Система автоматтык түрдө төмөнкүлөрдү калыбына келтирет: акча каражаттары чыгарыла турган эсепти; кызматкерлердин тизмесин; төлөнүүчү суммаларды.',
              4: 'Зарыл болсо, өзгөртүүлөрдү киргизиңиз.',
              5: '«Текшерүүгө жөнөтүү» баскычын басыңыз.',
            },
          },
        },
      },
    },
    EMPLOYEE: {
      EMPTY: 'Тизме бош',
      FILTER_EMPTY: 'Көрсөтүлгөн параметрлер менен кызматкер табылган жок',
      SEARCH_PLACEHOLDER: 'Кызматкерди издөө',
      PAY_CONTROL_NOT_AVAILABLE: 'Кызматкерлер менен аракеттер жеткиликсиз. Кол коюучулардын биринде PayControl жок.',
      ADD: {
        INN: 'Кызматкердин ИННи',
        INN_ERROR: '14 орундуу СТИНди киргизиңиз',
        LIMIT: 'Бир документке {count} кызматкерден ашык кошууга болбойт',
        TO_ADD: 'Кошула турган кызматкерлер:',
        ACCOUNT_REQUIRED: 'Картаны тандаңыз',
        SEARCH_RESULTS: 'Издөө натыйжалары',
        ALREADY_ADDED: 'Бул кызматкер мурунтан эле кошулган',
        ALREADY_IN_PROJECT: 'Кызматкер бул эмгек акы долбоорунун катышуучусу.',
        CARD_NUMBER: 'Картанын номери',
        ACCOUNT: 'Эсеп',
        NO_CARDS: 'Кызматкерде эмгек акы которуу үчүн жеткиликтүү карталар жок',
        LOADING_CARDS: 'Карталар жүктөлүүдө...',
        NOT_FOUND: 'Бул ИНН боюнча эч нерсе табылган жок',
        SAVE_CHANGES: 'Өзгөртүүлөрдү сактоо',
        SEND_FOR_SIGNING: 'Кол коюуга жөнөтүү',
        SUCCESS: 'Биринчи кол коюучунун ырастоосунан кийин кызматкер эмгек акы долбооруна кошулат.',
        SUCCESS_BULK: 'Биринчи кол коюучунун ырастоосунан кийин кызматкерлер эмгек акы долбооруна кайра кошулушат.',
        GOT_IT: 'Түшүнүктүү',
        SELECT_ACCOUNTS: 'Бардык кызматкерлер үчүн картаны тандаңыз',
        EMPTY_LIST: 'Жок дегенде бир кызматкер кошуңуз',
      },
      EDIT: {
        SENT_BUTTON: 'Түшүнүктүү',
        TITLE: 'Кызматкерди редакциялоо',
        NO_CARDS: 'Кызматкерде жеткиликтүү карталар жок',
        SAME_ACCOUNT: 'Жаңы эсеп учурдагы эсеп менен бирдей',
        SENT_MESSAGE: 'Биринчи кол коюучунун өзгөртүүлөрдү ырастоосунан кийин чегерүү эсеби өзгөртүлөт.',
      },
      RESTORE: {
        ACTION: 'Калыбына келтирүү',
        CONFIRM_TITLE: 'Кызматкерди эмгек акы долбооруна калыбына келтирүү керекпи?',
        CONFIRM_TITLE_BULK: 'Кызматкерлерди эмгек акы долбооруна калыбына келтирүү керекпи?',
        SENT_MESSAGE: 'Биринчи кол коюучу ырастагандан кийин кызматкер эмгек акы долбооруна кайра кошулат.',
        SENT_MESSAGE_BULK:
          'Биринчи кол коюучу ырастагандан кийин кызматкерлер ({count}) эмгек акы долбооруна кайра кошулат.',
        RESET_SELECTION: 'Тандоону тазалоо',
      },
      DELETE: {
        CONFIRM_TITLE: 'Кызматкерди эмгек акы долбоорунан өчүрүү керекпи?',
        CONFIRM_TITLE_BULK: 'Кызматкерлерди эмгек акы долбоорунан өчүрүү керекпи?',
        SENT_MESSAGE: 'Биринчи кол коюучу ырастагандан кийин кызматкер эмгек акы долбоорунан өчүрүлөт.',
        SENT_MESSAGE_BULK:
          'Биринчи кол коюучу ырастагандан кийин кызматкерлер ({count}) эмгек акы долбоорунан өчүрүлөт.',
      },
      FILTER: {
        TITLE: 'Чыпкалоо жана иреттөө',
        BY_CREATED_DATE: 'Кошулган датасы боюнча',
        NEWEST_FIRST: 'Алгач жаңыларын',
        OLDEST_FIRST: 'Алгач эскилерин',
        APPLY: 'Колдонуу',
        RESET: 'Баарын баштапкы абалга келтирүү',
      },
      CHIPS: {
        ADDED: 'Кошулгандар',
        FOR_SIGNING: 'Кол коюуга',
        DELETED: 'Өчүрүлгөндөр',
        REJECTED: 'Четке кагылгандар',
      },
      ERROR: {
        TITLE: 'Кызматкерлер туурасында маалыматты жүктөө мүмкүн болгон жок.',
      },
      STATUS_LABEL: {
        EMPLOYEE_IN_PROCESSING_BANK: 'Банк тарабынан иштелүүдө',
        EMPLOYEE_ERROR_CREATED: 'Кызматкерди кошуу мүмкүн болгон жок',
        EMPLOYEE_REJECTED: 'Биринчи кол коюучу тарабынан четке кагылды',
        EMPLOYEE_CLOSED: 'Өчүрүлдү',
        EMPLOYEE_CARD_NOT_LINKED_YET: 'Карта кошула элек',
        EMPLOYEE_CARD_FAILED_ADD: 'Картаны кошуу мүмкүн болгон жок',
        EMPLOYEE_CARD_BLOCKED: 'Карта бөгөттөлгөн',
        EMPLOYEE_CARD_SUCCESS: 'Кызматкер кошулду',
        EMPLOYEE_AWAITING_CREATION: 'Кошулушун күтүүдө',
        EMPLOYEE_AWAITING_EDIT: 'Редакцияланышын күтүүдө',
        EMPLOYEE_AWAITING_CLOSING: 'Өчүрүлүшүн күтүүдө',
        UNKNOWN: 'Белгисиз статус',
      },
    },
    STATEMENT: {
      DIALOG: {
        RETURN: 'Артка',
        SALARY_RELOADING: 'Ведомостту кайра жүктөө процесси жүрүп жатат...',
        STATEMENT_IS_REJECTED: 'Ведомостту четке кагуу процесси жүрүп жатат...',
        STATEMENT_REJECTED: 'Ведомость четке кагылды',
        SENDING_STATEMENT: 'Ведомостту кол коюуга жөнөтүү процесси жүрүп жатат....',
        STATEMENT_SENT: 'Ведомость ийгиликтүү жөнөтүлдү',
        STATEMENT_SIGNED: 'Ведомостко ийгиликтүү кол коюлду',
        STATEMENT_IS_SIGNED: '“{sum} {currency}” суммасына ведомость кол коюу процессинде турат',
      },
      COLUMN_TABLE: {
        NUMBER: '№',
        FILE_NAME: 'Аты',
        TOTAL_AMOUNT: 'Жалпы сумма',
        NUMBER_CARD: 'Карт-эсептин номери',
        DOWNLOAD_DATE: 'Түзүлгөн датасы',
      },
      EMPTY: 'Жүктөлгөн ведомосттор жок',
      ERROR: {
        TITLE: 'Ведомостун жүктөө  учурунда ката кетти',
      },
    },
    CONTRACT: {
      TITLE: 'Айлык акы келишими боюнча маалымат',
      ID: 'Айлык акы долбоорунун IDси:',
      ACCOUNT: 'Транзиттик эсеп:',
      STATUS_LABEL: {
        CONTRACT_ON_VERIFICATION: 'Келишим верификацияда',
        CONTRACT_VERIFICATED: 'Келишим верификатор тарабынан жактырылган',
        CONTRACT_REJECTED: 'Келишим верификатор тарабынан четке кагылган',
        CONTRACT_PENDING_CLOSURE: 'Келишим жабылышын күтүүдө',
        CONTRACT_CLOSED: 'Келишим жабылды',
        CONTRACT_PENDING_UNCLOSE: 'Келишим ачылышын күтүүдө',
      },
    },
    DOWNLOAD: {
      TEXT: ' Үлгүнү жүктөө',
      ERROR: ' Ведомостун жүктөө  учурунда ката кетти.',
      ERROR_HELP: ' Сураныч, “Дагы бир жолу жүктөө” баскычын дагы бир жолу басып көрүңүз',
      DOWNLOADING_STATEMENT: 'Ведомост жүктөлүүдө',
    },
    ERROR: {
      TITLE: ' Ведомостун жүктөө  учурунда ката кетти',
      MIN_AMOUNT: '1 {currency} ашык сумма киргизиңиз',
      MAX_AMOUNT: '1 000 000 000 {currency} чейинки сумма киргизиңиз',
      BALANCE_IS_LESS_AMOUNT_ERROR: 'Эсепте каражат жетишсиз',
    },
    NOTIFICATION: {
      STATUS: {
        ERROR: {
          TEXT: 'Банк айлык маянанын ведомостун четке какты Сумма {amount} {currency}.',
        },
        SUCCESS: {
          TEXT: ' Банк айлык маянанын ведомостун жактырды Сумма {amount} {currency}.',
        },
      },
    },
  },
  LETTER: {
    DOWNLOAD: {
      ERROR: 'Файлды жүктөө учурунда ката кетти',
      ERROR_HELP: 'Сураныч, Дагы бир жолу жүктөө баскычын басыңыз',
    },
    TITLE: 'Каттар',
    ATTACHED_FILE: 'Бекитилген файл',
    CREATED: 'Түзүлгөн: ',
    REVOKE: 'Четке кагуу',
    SIGN: 'Кол коюу',
    FOR_SIGN: 'Кол коюуга',
    DELETE: 'Өчүрүү',
    NOTIFICATION: {
      TITLE: 'Банктан жаңы кат',
      TEXT: 'Банктан сиздин №{number} катыңызга жооп келди',
    },
    EMPTY: {
      OUTGOING: 'Сизде чыккан каттар жок',
      INCOMING: 'Сизде кирген каттар жок',
    },
    ERROR: {
      TITLE: 'Каттарды жүктөө учурунда ката кетти',
    },
    NAV: {
      OUTGOING: 'Чыккан',
      INCOMING: 'Кирген',
    },
    CREATE: {
      CREATE_LETTER: 'Кат түзүү',
      DATE: 'Түзүлгөн күнү',
      NAME_COMPANY: 'Компаниянын аталышы ',
      TOTP: 'Банкка катты жөнөтүүнү тастыктоо үчүн сураныч, ТОТР-кодду жазыңыз',
      ENTER_TOTP: 'ТОТР-кодду жазыңыз',
      SELECT: {
        SUBJECT: 'Каттын темасы',
        SUBJECT_EMPTY: 'Каттын темасын тандоо үчүн басыңыз ',
        MONEY_TRANSFER: 'Акча которуулары боюнча документтер',
        PAYMENT_CANCELLATION: 'Төлөмдү жокко чыгаруу',
        PERSONAL_DOCUMENT: 'Персоналдык документтер',
        OTHER: 'Башкасы',
      },
      ENTER_SUBJECT: 'Сиздин каттын темасын жазыңыз',
      ENTER_TEXT: 'Каттын текстин жазыңыз',
      ATTACH_FILE: 'Файлды бекитүү',
      ALLOWED_TYPES: '(10 МБ, файлдын уруксат берилген түрлөрү: .xls .xlsx .doc .docx .pdf .jpg .png .pptx .zip .txt)',
      FOR_SIGN: 'Кол коюуга',
      RULES: {
        ENTER_SELECT: 'Бул түшүүчү тизмеден түзүлүүчү каттын темасын тандаңыз',
        ENTER_TEXT: 'Түзүлүүчү каттын текстин бул боштукка жазыңыз',
        ENTER_OTHER_TEXT: ' Түзүлүүчү каттын темасын бул боштукка жазыңыз',
        INVALID_EXTENSION: {
          FIRST:
            'Тыюу салынган түрдөгү файл бекитилген. Файлдын уруксат берилген түрлөрү: .xls .xlsx .doc .docx .pdf .jpg .png .pptx .zip .txt',
          SECOND: 'Сураныч, бекитилген файлды өчүрүңүз жана уруксат берилген түрдөгү файлды жүктөңүз',
        },
        FILE_LARGE: {
          FIRST: 'Сиз тараптан бекитилген файлдын өлчөмү максималдык кабыл алынган 10 мегабайт өлчөмдөн көп.',
          SECOND: 'Сураныч, бекитилген файлды өчүрүңүз жана өлчөмү кичирээк  файлды жүктөңүз',
        },
        INVALID_TOTP: 'Сиз туура эмес ТОТОР-кодду жазып алдыңыз. Сураныч, кайра туура ТОТР-кодду жүктөңүз.',
        INVALID_CHARACTER_TITLE: 'Сиз түзүлүүчү каттын темасында жараксыз символдорду колдондуңуз: ',
        INVALID_CHARACTER_MESSAGE: 'Сиз түзүлүүчү каттын текстинде жараксыз символдорду колдондуңуз: ',
      },
      DIALOG: {
        SENDING: 'Катты жөнөтүү',
        REPEAT: 'Кайталоо',
        NOT_SEND: 'Кат жөнөтүлгөн жок',
        COME_BACK: 'Артка кайтуу',
        SENT_FOR_SIGN: 'Кат кол коюуга жөнөтүлдү',
        COME_BACK_LETTER: 'Каттарга өтүү',
        ERROR_AFTER_DRAFT: 'Кат кол коюуга жөнөтүлбөй калды. Кат черновик катары сакталды',
        SUCCESS_DELETE: 'Кат жокко чыгарылды',
        FAILED_DELETE: 'Кат жокко чыгарылбай калды',
        SAVED_TO_DRAFT: 'Кат черновик катары сакталды',
        FAILED_SAVED_TO_DRAFT: 'Кат черновик катары сакталбай калды',
        FAILED_SEND_FOR_SIGN: 'Кат кол коюуга жөнөтүлбөй калды',
        SIGN_LETTER: 'Катка кол коюлду',
        FAILED_SIGN_LETTER: 'Катка кол коюлбай калды',
        SUCCESS_REVOKE: 'Кат четке кагылды',
        FAILED_REVOKE: 'Кат четке кагылган жок',
      },
    },
    STATUS: {
      OUTGOING: {
        NOT_PROCESSED: 'Иштетилген жок',
        IN_PROCESSING: 'Иштелүүдө',
        PROCESSED: 'Иштетилди',

        ON_VERIFICATION: 'Кол коюуда',
        FIRST_SIGN_IN_PAY_CONTROL: 'Кол коюуда',
        TIMEOUT_CANCELED_SIGN_ONE: 'Тайм-аут боюнча баш тартуу',
        CANCELED_SIGN_ONE: 'Четке кагылды',
        DRAFT: 'Черновик',
      },
      INCOMING: {
        NOT_PROCESSED: 'Жаңы кат',
        PROCESSED: 'Окулду',
      },
    },
  },

  OUTLET: {
    LUNCH_BREAK: 'Түшкү тыныгуу',
    NEW_POINT: 'Жаңы cатуу түйүнү',
    CASH_ADD: 'Кассаны кошуу',
    POINT_ADD: 'Сатуу түйүндү кошуу',
    CASH: 'Касса',
    SALE_POINTS: 'Сатуу түйүндөрү',
    SALE_POINT: 'Сатуу түйүнү',
    ALL_POINTS: 'Бардык түйүндөр',
    EMPLOYEES: 'Кассирлер',
    CREATE_QR: 'QR-код түзүү',
    SHOW_ALL: 'Баарын көрүү',
    QR_CODE: 'QR-код',
    NAME: 'Аты',
    DELETE_ALL: 'Баарын өчүрүү',
    SELECT_ALL: 'Баарын тандоо',
    ADD_EMPLOYEE: 'Кассирди кошуу',
    ADD_ADDRESS: 'Дарек кошуу',
    ADD_PHONE: 'Номер кошуу',
    CHANGE_ACCOUNT_SETTINGS: 'Орнотууларда эсептин кирүү мүмкүнчүлүгүн өзгөртүңүз',
    SORT_NEWEST: 'Жаңыларынан баштоо',
    SORT_OLDEST: 'Эскилерден баштоо',
    SORT_ALPHABETICALLY: 'Алфавит боюнча',
    NEW_CASH: 'Жаңы касса',
    GRANT_ACCESS: 'Кирүү мүмкүнчүлүгүн берүү',
    EMPTY_EMPLOYEES: 'Азырынча кассирлер жок',
    EMPTY_SEARCH_EMPLOYEES: 'Мындай кассирлер жок',
    EMPTY_SEARCH_POINT: 'Мындай аталыштагы сатуу түйүндөрү жок',
    POINT_ACCESS_DENIED: 'Сатуу түйүндөрүнө кирүү мүмкүнчүлүгү жок',
    CASH_ACCESS_DENIED: 'Кассаларга кирүү мүмкүнчүлүгү жок',
    EMPLOYEE_ACCESS_DENIED_CASH: 'Кассирдин кассаларга кирүү мүмкүнчүлүгү жок',
    EMPTY_CASHES: 'Мындай номердеги касса жок',
    ONBOARDING: {
      HEADER: 'Сатуу түйүнүн кошуңуз',
      SUB_HEADER: 'Тиркемеде сатууларды көзөмөлдөп, жаңы кассирлерди кошо аласыз',
      QR: 'Ар бир касса үчүн QR-код түзүңүз',
      HISTORY: 'Ар бир сатуу түйүндөрүнүн жана кассаны сатуулар тарыхын көрүңүз',
      ACCESS: 'Кассирлерге тарыхты көрүүгө мүмкүнчүлүк бериңиз',
      ADD_POINT: 'Сатуу түйүндөрүн кошуу',
    },
    REVOKE_ACCESS: 'Кирүү мүмкүнчүлүгүн кайтарып алуу',
    EDIT_WITH_KKM: 'Точкада ККМ-касса бар. Маалыматтарды өзгөртүү үчүн ККМ-кассаны алып салуу керек',
    FORM: {
      QUESTIONS: {
        NAME: 'Сатуу түйүндүн аталышы кандай?',
        ACCOUNT: 'Акчаны кайда түшүрүү керек?',
        ADDRESS: 'Дарек кошуу',
        PHONE: 'Сатуу түйүнү менен кантип байланышса болот?',
        SOCIAL: 'Түйүндүн дарегине жана социалдык тармактарына шилтемелер',
      },
      POINT_NAME: 'Сатуу түйүндүн аты',
      CHECK_NAME: 'Чектердин аталышы',
      CHECK_HINT: 'Квитанциялардын атын латын арибинде жазыңыз - ал сатуу квитанцияларында көрсөтүлөт',
      ACCOUNT_HINT: 'Эгерде сиз эсептешүү эсепти өзгөртсөңүз, сатуу түйүнү үчүн жаңы QR-кодду түзүңүз',
      REGION: 'Аймак',
      CITY: 'Район же шаар',
      DISTRICT: 'Район же айыл',
      ADMINISTRATIVE_TERRITORY: 'Административдик аймак',
      IN_BUILDING: 'Имараттын ичинде',
      NEARBY: 'Жакын жерде',
      COMPANIES_IN_BUILDING: 'Уюмду тандаңыз',
      STREET_OR_MKR: 'Көчө же кичирайон',
      HOUSE: 'Үй',
      POSTAL_CODE: 'Почта индекси',
      TRADE_CENTER_OR_MARKET_POINT: 'Соода борборундагы же базардагы чекит',
      WORKING_HOURS: 'Иш тартиби',
      WORKING_FROM: 'Башталышы',
      WORKING_TO: 'Аягы',
      SELECTED_COMPANY: 'Тандалган компания',
      NEARBY_COMPANIES: 'Жакынкы компаниялар',
      MAP_PICKER_TITLE: 'Дарек кошуу',
      ADDRESS_SEARCH_PLACEHOLDER: 'Компаниянын дарегин киргизиңиз',
      CURRENT_LOCATION: 'Учурдагы жайгашкан жер',
      GEOLOCATION_ERROR: 'Учурдагы жайгашкан жерди аныктоо мүмкүн болгон жок',
      LOAD_MORE_COMPANIES: 'Дагы көрсөтүү',
      COMPANY_BRANCHES_LOAD_ERROR: 'Компанияларды жүктөө мүмкүн болгон жок. Кайра аракет кылыңыз',
      ORGANIZATION_BRANCHES: 'Уюмдун филиалдары',
      SELECT_BRANCH: 'Филиалды тандаңыз',
      SUGGEST_ORG_BRANCHES: '{count} филиал, {city}',
      ADDRESS_NOT_FOUND: 'Дарек табылган жок',
      TWO_GIS_NOT_FOUND: 'Эч нерсе табылган жок, издөө сурамын тактап көрүңүз',
      ADD_PHONE: 'Номерди кошуу',
      PHONES: 'Телефон номерлери',
      TWO_GIS: 'Түйүндүн 2ГИСтеги дарегине шилтеме',
      TWO_GIS_SHORT: '2ГИС',
      COPY_LINK: 'Шилтеме көчүрүлдү',
      ENTER_TWO_GIS: '2ГИСке шилтемени киргизиңиз',
      SOCIAL_NETWORK: 'Түйүндүн социалдык тармагына шилтеме',
      SOCIAL_NETWORK_SHORT: 'Социалдык тармактар',
      PLACED_IN_MALL: 'Сатуу жайы соода борборунда же базарда жайгашат',
      ADD_SOCIAL_NETWORK: 'Кошуу',
      ENTER_SOCIAL_NETWORK: 'Социалдык тармакка шилтеме киргизиңиз',
      MALL: 'Соода борбору',
      MALL_NAME: 'Соода борборунун аталышы',
      FLOOR: 'Кабат',
      BOUTIQUE: 'Бутиктин номери',
      MARKET: 'Базар',
      MARKET_NAME: 'Базардын аталышы',
      MARKET_ROW: 'Катар',
      CONTAINER: 'Контейнер',
    },
    RULE: {
      SAME_PHONE: 'Бул номер бар. Башка номерди жазып көрүңүз',
      ACCOUNT_FORBIDDEN: 'Эсепке кирүү мүмкүнчүлүгү жок',
    },
    DIALOG: {
      POINT_IS_READY: '«{name}» сатуу түйүнү ишке даяр',
      ADD_MORE_POINT: 'Дагы бир сатуу түйүнүн кошуу',
      TO_POINT_LIST: 'Сатуу түйүндөрүнүн тизмесине',
      CHANGE_ACCOUNT: {
        TITLE: 'Эсеп — бардык соода түйүндөрү үчүн өзгөртүлөт',
        DESCRIPTION:
          '№{number} келишиминдеги түйүндөр бир эсепке катталган. Ал эсепти өзгөртсөңүз, автоматтык түрдө бул түйүндөрдө дагы алмашат:',
      },
      QT_HINT_INVITED:
        'Шилтемени жана QR кодун жөнөтүңүз. Кассир Optima Business киргенде, ага "кассирлер"бөлүмүнө кирүүгө уруксат бериңиз',
      QR_HINT:
        'Кассалардын QR-коду иштей берет, бирок акча башка эсептешүү эсебине түшөт. Акча жаңы эсептешүү эсебине түшүшү үчүн QR-кодду кайра түзүңүз',
      CASH_IS_READY: 'Касса {code} колдонууга даяр',
      CASH_IS_READY_HINT: '«{name}» жеткиликтүү',
      ADD_MORE_CASH: 'Дагы бир кассаны кошуу',
      TO_CASH_LIST: 'Кассалардын тизмесине',
      REVOKE_ACCESS_TITLE: 'Бардык кассаларга кирүү мүмкүнчүлүгүн жокко чыгарууну каалайсызбы?',
      REVOKE_ACCESS_MESSAGE: '{name} сатууларды көзөмөлдөй албайт',
      DO_YOU_WANT_REVOKE: 'Бардык кассаларга кирүү мүмкүнчүлүгүн жокко чыгаргыңыз келеби?',
      FINISH_CHANGES_TO_REVOKE: 'Өзгөртүүлөрдү бүтүрүп, "кирүү мүмкүнчүлүгүн жокко чыгаруу"баскычын басыңыз',
      DELETE_CASHIER: 'Кассир «{name}» өчүрүүнү каалайсызбы?',
      DELETE_CASHIER_MESSAGE: 'Кассир {name} Оptima Businessке кайра кире албайт',
      CASHIER_DELETED: 'Кассир өчүрүлдү',
      CHANGES_WILL_NOT_BE_SAVED: 'Өзгөрүүлөр сакталбайт',
      ACCESS_REVOKED: 'Уруксат жокко чыгарылды',
      CASHIER_STATUS_INFO: 'Тиркемеге кирүү үчүн кассирге логинди жана убактылуу сырсөздү киргизүү керек',
      CASHIER_STATUS_SUCCESS: 'Кассир каттоодон өткөн жана тиркемени колдоно алат',
      CONFIRM_CLOSE: {
        ADD_OUTLET: 'Сатуу түйүндүн дайындары сакталбайт',
        ADD_CASH: 'Кассанын дайындары сакталбайт',
        EDIT_CASH: 'Кассанын өзгөрүүлөрү сакталбайт',
        ADD_CASHIER: 'Кассирдин дайындары сакталбайт',
      },
      ACTION: {
        REVOKE: 'Кайтаруу',
        COPY_LINK: 'Шилтемени көчүрүү',
      },
    },
    MORE_OUTLETS: 'дагы көбүрөөк түйүндөр | дагы {count} түйүн | дагы {count} түйүндөр | дагы {count} түйүндөр',
    MORE_EMPLOYEES: 'көбүрөөк кызматкерлер | {count} кызматкер | {count} кызматкерге | {count} кызматкерлер',
    MORE_CASHES: 'көбүрөөк кассалар | {count} касса | {count} кассалар | {count} кассалар',
    MORE_CASHES_PREFIX:
      'дагы көбүрөөк кассалар | дагы {count} кассалар | дагы {count} кассалар | дагы {count} кассалар',
    DETAILS: {
      SALES: 'Сатуулар',
      CASH_REGISTERS: 'Кассалар',
      ABOUT_POINT: 'Түйүн жөнүндө',
      ON_VERIFICATION: 'Каралып жатат',
      DECLINED: 'Четке кагылды',
      APPROVED: 'Кабыл алынган',
      LIST_QR: 'QR тизмеси',
    },
    EMPLOYEE: {
      TITLE: 'Жаңы кассир',
      ACCESS_OTHER_CASH: 'Башка кассаларга кирүү мүмкүнчүгүн берүү',
      INFO_SUBTITLE: 'Кассирдин маалыматтарын көрсөтүңүз',
      ACCESS_SUBTITLE: 'Кандай кассаларга кирүү мүмкүнчүлүгүн берүү керек?',
      ACCESS_SELECTED_CASH: 'Кайсы кассирлерге кирүү мүмкүнчүлүгүн берүү керек?',
      NOT_FOUND: 'Мындай СТИН менен Оптиманын кардары табылган жок',
      DID_NOT_SELECTED: 'Жок дегенде бир кассаны тандаңыз',
      ALREADY_ACTIVE: 'Мындай СТИН менен кассир бар',
      SELECT_ALL: 'Бардык кассаларды тандоо',
      CASH_NUMBER: 'Кассанын номери',
      ADD_MORE: 'Башка кассирлерди кошуу',
      TO_LIST: 'Кассирлердин тизмесине',
      MUST_ENTER_LOGIN_PASSWORD: '{name} тиркемеге кирүү үчүн логин жана убактылуу сырсөздү киргизүү керек',
      EMPLOYEE_WITH_ACCESS: 'Кирүү укугу бар кассирлер',
      FIRST_OR_SECOND_NAME: 'Аты же фамилиясы',
      ABOUT_EMPLOYEE: 'Кассир жөнүндө',
      CASHES: 'Кассалар',
      QR_ADD: 'QR кодду түзүү',
      INN_ADD: 'СТИН боюнча кошуу',
    },
    STATUS: {
      INIT: 'Кирүү маалыматтары жиберилди',
      CONFIRM: 'Кошулду',
      ON_VERIFICATION: 'Каралып жатат',
      DECLINED: 'Четке кагылды',
      APPROVED: 'Кабыл алынган',
    },
    BANNER: {
      TITLE: 'Бардык сатуу түйүндөрүн бир жерге топтодук',
      DESCRIPTION: 'Эми терминалдар жана QR төлөмдөр боюнча толук маалыматты көрө аласыз',
    },
    HISTORY_INVITED: 'Өтүнмөнүн тарыхы',
    APPROVED_CASHIER: '"{name}" сиздин компанияга кошулду',
    DECLINED_CASHIER: '"{name}" арызы жокко чыгарылды',
    CANCEL_CASHIER: '"{name}" кассиринин арызын жокко чыгарасызбы?',
    NOT_CANCEL: 'Жок, жокко чыгарбаңыз',
    YES_CANCEL: 'Ооба, жокко чыгаруу',
    ACCEPTED: '{name} кабыл алды',
    REJECTED: '{name} четке какты',
    APPLICATION_SENT_TO_MANAGER: 'Арыз жетекчиге\nжиберилди',
    INVITED: 'Чакыруулар',
    PAYMENT_FOR: '{name} үчүн төлөм',
    LAST_PAYMENT: 'Акыркы төлөм',
    NO_FIRST_PAYMENT: 'Колдонуучу азырынча алгачкы төлөмдү жүргүзө элек',
    QR_SORT_BY_DATE: 'QRдын түзүлгөн датасы боюнча',
    QR_SORT_NEW: 'Жаңы',
    QR_SORT_OLD: 'Эски',
    ENTER_PURPOSE: 'Багыттамасын киргизиңиз',
    LAST_TRANSACTION_DATE_TIME: 'Акыркы төлөм боюнча',
    NO_PERSONAL_QR: 'Сизде түзүлгөн персоналдык QR жок',
    AMOUNT_EDITING: 'Сумманы өзгөртүү',
    AMOUNT_EDITING_DENIED: 'Уруксат берилген эмес',
    AMOUNT_EDITING_ALLOWED: 'Уруксат берилет',
    PERSONAL_QR_UPDATED:
      'Өзгөртүүдин кийин жеке QR коддун маалыматтары жана суммасы жаңыртылат. Жаңыртылган QR кодду сактап, кайра басып чыгарыңыз же жүктөп алыңыз',
  },
  INSTALLMENT: {
    TITLE: 'Бөлүп төлөөгө сатуулар',

    TABS: {
      HISTORY: 'Тарыхы',
      OUTLET: 'Түйүндөр',
      ABOUT: 'Өнүмдөр',
    },
    FILTER: {
      THREE: '3 күндүн ичинде',
      WEEK: 'Жума үчүн',
      MONTH: '30 күндүн ичинде',
    },
    STATUS: {
      ALL: 'Баары',
      UNDER_REVIEW: 'Иштеп чыгууда',
      AWAITING_DELIVERY_OF_GOODS: 'Ырастоону күтүүдө',
      CREDITING_FUNDS: 'Акча эсебиңизге которулууда',
      ISSUED: 'Аткарылды',
      REFUSED: 'Четтетилди',
      ACTIVE: 'Активдүү',
      NON_ACTIVE: 'Активдүү эмес',
      IN_PROCESS: '@:INSTALLMENT.STATUS.UNDER_REVIEW',
      ACCEPTED: '@:INSTALLMENT.STATUS.AWAITING_DELIVERY_OF_GOODS',
      PROCESSED: '@:INSTALLMENT.STATUS.ISSUED',
      REJECTED: '@:INSTALLMENT.STATUS.REFUSED',
      ERROR: 'Ката',
    },
    FILL_FIELD: 'Жокко чыгаруу себепин киргизиңиз',
    INCOMING_FOR: '{day} күн киреше',
    CONNECT: '{product} кошуу',
    EMPTY: 'Эч нерсе табылган жок',
    PERIOD: 'Иштөө мезгили',
    PERIOD_INFO: 'Бөлүп төлөө төлөмдөрү автоматтык түрдө узартылат. Эгер аны өчүрүүнү кааласаңыз банкка кайрылыңыз',
    TERM_COMMISSION: 'Мөөнөтү жана комиссиялык акысы',
    CONTACT_INFO: 'Байланыш маалымат',
    CONTACT_PERSON: 'Байланыш адам',
    MY_CATEGORY: 'Менин категориям',
    GO_TO_SALES: 'Сатууларга өтүү',
    EMAIL: 'Email',
    TRY_AGAIN: 'Дагы бир жолу аракет кылуу',
    TO_SALE_LIST: 'Сатуулар тизмесине өтүү',
    CONFIRM_SALE: 'Сатууну ырастоо',
    SALE_REJECT: 'Сатуу четтетилди',
    SALE_CONFIRMED: 'Сатуу ырасталды',
    SALE: 'Сатуу',
    DETAILS: 'Кененирээк',
    CONTRACT_NUMBER: 'Келишимдин номери',
    REPAYMENT_PERIOD: 'Төлөө мөөнөтү',
    CUSTOMER: 'Сатып алуучу',
    REJECT_TITLE: 'Баш тартуунун себеби эмнеде?',
    REJECT_SALE: 'Сатуудан баш тартасызбы',
    PLACEHOLDER_REJECT: 'Бул товар бөлүп төлөөгө берилбей',
    REJECT_REASON: 'Четтетүүнүн себеби',
    MONTH: 'ай',
    ADDRESS: 'Банк кеңсесинин дареги',
    PROFIT_ALL_TIME: 'Жалпы киреше',
    FROM:
      '<span class="entity-installment-product-card__value">{date}</span>\n' +
      '          <span class="entity-installment-product-card__label">Баштап</span>',
    TO:
      '<span class="entity-installment-product-card__value">{date}</span>\n' +
      '          <span class="entity-installment-product-card__label">Чейин</span>',
    ONBOARDING: {
      TO_SALE: 'Өнүмдөргө кайтуу',
      PAY_DA: {
        TITLE_PRODUCT: 'ПАЙДА! менен сатууларды көбөйт!',
        TITLE_BANK: 'Эсептешүү эсепти ачкан банктын кеңсесине кайрылыңыз',
        DESCRIPTION_CONNECT:
          'Паспортуңузду жаныңызга алып алыңыз. ПАЙДА! төлөм кабыл алууну кошуп беребиз — көп убакыт албайт',
        DESCRIPTION_MONEY: 'Сиз акчаны дароо толук аласыз, кардар болсо банкка бөлүп төлөйт',
        DESCRIPTION_SALE: 'Сатууларды көбөйтүп, орточо чекти жогорулата аласыз',
        DESCRIPTION_QR: 'Сатуу түйүнүнү QR-кодуна төлөө',

        BUTTON_GET_CASH: 'Көбүрөөк сатууну каалайм',
        SEND_APPLICATION_TO_CONNECT: 'Туташуу өтүнүчүн жөнөтүңүз',
        CONTACT_NAME: 'Аты',
        SEND_APPLICATION: 'Өтүнмөнү жөнөтүү',
        APPLICATION_SENT: 'Өтүнмө жөнөтүлдү',
        APPLICATION_SENT_HINT: 'Биз сизге жакында чалып, чоо-жайын талкуулайбыз',

        CREATE_OUTLET: 'Сатуу түйүнүн кошуу',
        CREATE_OUTLET_LATER: 'Кийинчирээк кошуу',
        CREATE_DESCRIPTION: 'ПАЙДА! аркылуу сатууларды баштоо үчүн сатуу түйүнүн кошуу керек. Аны азыр кошсоңуз болот',
      },
      TEZ_CREDIT: {
        TITLE_PRODUCT: 'ТЕЗ-бөлүп төлөөгө сатыңыз',
        TITLE_BANK: 'Эсептешүү эсепти ачкан банктын кеңсесине кайрылыңыз',
        DESCRIPTION_CONNECT:
          'Паспортуңузду жаныңызга алып алыңыз. ТЕЗ-бөлүп төлөө менен төлөм кабыл алууну кошуп беребиз — көп убакыт албайт',
        DESCRIPTION_MONEY: 'Сиз акчаны дароо толук аласыз, кардар болсо банкка бөлүп төлөйт',
        DESCRIPTION_SALE: 'Сатууларды көбөйтүп, орточо чекти жогорулата аласыз',
        DESCRIPTION_QR:
          'Кардар бөлүп төлөөнү сатуу түйүнүнүн QR-коду аркылуу тариздейт, а сиз товарды берүүнү ырастайсыз',
        BUTTON_GET_CASH: 'Кантип сатып баштайт',
      },
    },
  },
  NPT: {
    BANNER: {
      TITLE: 'Которуу үчүн салык карызыңызды төлөңүз!',
      DESCRIPTION: 'Учурдагы эсебиңизди ачкан банк кеңсесине кайрылыңыз',
    },
    DIALOG: {
      TITLE: 'Салык боюнча карыздар',
      DEBT: 'Карыз  {number}',
      PAYMENT_REQUEST: 'Налоговое платежное требование',
      NOTICE: 'Извещение',
    },
  },
  INVOICE: {
    LIST_TITLE: 'Төлөөгө эсептер',
    TITLE: 'Төлөөгө эсеп',
    DIALOG: {
      CONFIRM_CLOSE: {
        LABEL: 'Төлөөгө эсептин черновиги сакталбайт',
      },
    },
    ISSUE: 'Эсеп чыгаруу',
    INCOMING: 'Кирешелер',
    OUTGOING: 'Чыгашалар',
    PRODUCT: 'Товарлар жана кызматтар',
    ALLOW_PARTIAL_PAYMENT: 'Жарым-жартылай төлөөгө уруксат берүү',
    MOBILE_TABS: {
      INVOICES: 'Эсептер',
      CATALOG: 'Каталог',
    },
    OPEN_INVOICE: 'Эсепти ачуу',
    AVAILABLE_AROUND_THE_CLOCK: '24/7 жеткиликтүү',
    PAYMENT_AMOUNT: 'Төлөм суммасы',
    CREATED_AT: 'Түзүлгөн',
    EXPIRES_AT: 'Эсептин жарактуулук мөөнөтү',
    IN_PROGRESS: 'Иштелүүдө',
    PAY: 'Төлөө',
    REJECT: 'Четке кагуу',
    ISSUED_INVOICE: 'Чыгарылган эсеп',
    INVOICE_PAYMENT: 'Эсеп боюнча төлөм',
    INTRABANK_TRANSFER_BY_INVOICE: 'Төлөөгө эсеп боюнча банк ичиндеги которуу',
    PRODUCTS_MORE: '+ {count} товар',
    EMPTY_CATALOG: 'Каталогдо азырынча товарлар жана кызматтар жок\nБиринчи позицияны түзүп, эсеп чыгарууда колдонуңуз',
    EMPTY_OUTGOING:
      'Сизде азырынча чыгыш эсептер жок.\nТоварлар же кызматтар үчүн төлөм талап кылуу үчүн биринчи эсепти түзүңүз.',
    EMPTY_OUTGOING_ACTION: 'Эсеп түзүү',
    EMPTY_INCOMING: 'Сизде азырынча кирген эсептер жок.\nБул жерде башка компаниялар жөнөткөн эсептер көрсөтүлөт.',
    COUNTERPARTY: {
      SUPPLIER: 'Жеткирүүчү',
      BUYER: 'Сатып алуучу',
    },
    TYPE_SHORT: {
      INDIVIDUAL: 'жеке жакка',
      LEGAL: 'юр. жакка',
    },
    TYPE_FULL: {
      INDIVIDUAL: 'Жеке жакка төлөөгө эсеп',
      LEGAL: 'Юридикалык жакка / ЖИ төлөөгө эсеп',
    },
    TYPE_MOBILE: {
      INDIVIDUAL: 'Жеке жакка төлөөгө эсеп',
      LEGAL: 'Юридикалык жакка / ЖИ төлөөгө эсеп',
    },
    TYPE_FILTER: {
      TITLE: 'Эсептин түрү',
      LEGAL: 'Юридикалык жактар / ЖИ',
      INDIVIDUAL: 'Жеке жактар',
    },
    SERVICE_DIALOG: {
      TRIGGER: 'Кызматтын шарттары жана мүмкүнчүлүктөрү',
      TITLE: 'Кызматтын шарттары жана мүмкүнчүлүктөрү',
      DESCRIPTION:
        'Төлөм эсептери кызматы товарлар жана кызматтар үчүн төлөмдөрдү тез кабыл алууга мүмкүндчүлүк берет — Оптима Банктын ичинде жана башка банктардан',
      INDIVIDUAL_DESCRIPTION:
        'Жеке жактарга төлөөгө эсептер товарлар жана кызматтар үчүн төлөмдөрдү Оптима Банктын ичинде тез кабыл алууга мүмкүндүк берет.',
      TARIFFS_TITLE: 'Тарифтер',
      FOR_SOLE_PROPRIETORS: 'Жеке ишкерлер үчүн',
      FOR_LEGAL_ENTITIES: 'Юридикалык жактар үчүн',
      INTERNAL_BANK_LABEL: 'Оптима Банктын ичинде',
      OTHER_BANKS_LABEL: 'башка банктардан',
      SOLE_INTERNAL_VALUE: '0,8%',
      SOLE_OTHER_VALUE: '1%',
      LEGAL_INTERNAL_VALUE: '1%',
      LEGAL_OTHER_VALUE: '1%',
      TARIFFS_NOTE: 'Айрым кардарлар үчүн жеке тарифтер колдонулушу мүмкүн',
      FEATURES_TITLE: 'Мүмкүнчүлүктөр',
      FEATURE_1: 'Банк ичинде жана башка банктарга эсеп чыгаруу',
      FEATURE_2: 'Акча каражаттарынын заматта эсепке түшүшү',
      FEATURE_3: 'Төлөм статусунун автоматтык жаңыртылышы',
      FEATURE_4: 'Кызмат 24/7 иштейт',
      FEATURE_5: '1С менен интеграция',
      ACTION: 'Артка кайтуу',
    },
    STATUS_INFO_DIALOG: {
      REJECTED_TITLE: 'Статус Четке кагылды',
      REJECTED_DESCRIPTION: 'Төлөөчү эсепти төлөөдөн баш тартты.',
      CANCELLED_TITLE: 'Статус Жокко чыгарылды',
      CANCELLED_DESCRIPTION: 'Эсеп төлөнгөнгө чейин жокко чыгарылды.',
      EXPIRED_TITLE: 'Статус Мөөнөтү өттү',
      EXPIRED_DESCRIPTION: 'Төлөө мөөнөтү өттү. Эсеп жараксыз.',
      BACK: 'Артка кайтуу',
    },
    COUNT_WIDGET: {
      TITLE: 'Сизде {count} кириш төлөөгө эсеп бар',
      ACTION: 'Эсепке өтүү',
    },
    PRODUCTS_TABLE: {
      SEARCH_PLACEHOLDER: 'Табуу',
      ADD_BUTTON: 'Товар же кызмат кошуу',
      ADD_TITLE: 'Товар же кызмат кошуу',
      CODE: 'Код',
      NAME: 'Аталышы',
      UNIT: 'Өлчөм бирдиги',
      QUANTITY: 'Саны',
      PRICE: 'Салыктар менен баа',
      TAXES: 'Салыктар',
      ACTIONS: 'Аракеттер',
      DELETE_TITLE: 'Товарды өчүрүүнү каалайсызбы?',
      DELETE_MESSAGE: '«{name}» товарынын маалыматтары сакталбайт',
      SAVED_TITLE: 'Өзгөртүүлөр сакталды',
      PRODUCT_SAVED_TITLE: 'Товар каталогго сакталды',
      EDIT_TITLE: 'Түзөтүү',
      NAME_LABEL: 'Аталышы',
      PRICE_LABEL: 'Салыктар менен баа',
      UNIT_LABEL: 'Өлчөм бирдиги',
      VAT_LABEL: 'КНС,%',
      SALES_TAX_LABEL: 'СсП,%',
      VAT_RATE: 'КНС',
      SALES_TAX_RATE: 'СсП',
      AMOUNT: 'Сумма',
      EMPTY: 'Азырынча товар/кызмат жок',
      CANCEL_TITLE: 'Товарды кошпоого болобу?',
      CANCEL_MESSAGE: 'Эгер киргизсеңиз, маалыматтар сакталбайт',
    },
    CREATE_PARAMS_TITLE: 'Эсептин параметрлери',
    CREATE_RECIPIENT_TITLE: 'Эсеп алуучу',
    PRODUCTS_TABLE_LIMIT_HINT:
      'Төлөм эсебинде {count}ге чейин товар жана/же кызмат кошууга болот, жалпы суммасы {sum} сомго чейин',
    CASH_NUMBER_LABEL: 'Кассанын номери',
    ACCOUNT_NUMBER_LABEL: 'Төлөм эсебинин №',
    ACCOUNT_NUMBER_AUTO_HINT: 'Эгер эсеп номери көрсөтүлбөсө, ал автоматтык түрдө ыйгарылат',
    VALIDITY_PERIOD_LABEL: 'Иш жүздөгү мөөнөт',
    VALIDITY_EXPIRES_AT_HINT: 'Эсептин жарактуулук мөөнөтү: {date}',
    ACCOUNT_NUMBER: 'Эсептин №',
    VALIDITY_DAYS: 'Эсептин жарактуу күндөрүнүн саны',
    VALIDITY_DAYS_HINT: 'Бош же 0 калтырсаңыз, эсеп 23:59га чейин жарактуу болот',
    VALIDITY_DAYS_RANGE: '0 ден 30 га чейинки маанини киргизиңиз',
    SALE_POINT_ACCOUNT: 'Каражаттар ушул эсепке түшөт - {account}',
    RECIPIENT_NAME_INN: 'Алуучунун аталышы/ИНН',
    RECIPIENT_SEARCHING: 'Алуучу изделип жатат…',
    PURPOSE_COMMENT: 'Төлөмдүн максаты/Комментарий',
    PURPOSE_PAYMENT_HINT: 'Төлөмдүн дайындалышын көрсөтүңүз: эмне үчүн же ким үчүн төлөм',
    CONTINUE: 'Улантуу',
    STEPS: {
      REQUISITES: 'Реквизиттер',
      PRODUCTS: 'Товарлар жана/же кызматтар',
    },
    CREATE_INDIVIDUAL: 'Жеке жакка төлөөгө эсеп',
    CREATE_LEGAL: 'Юридикалык жакка / ЖИ төлөөгө эсеп',
    CONFIRM_ISSUE_TITLE: 'Төлөөгө эсеп түзүлдү.',
    CONFIRM_ISSUE_MESSAGE: 'Жөнөтүү ыкмасын тандаңыз',
    CONFIRM_ISSUE_ACTION: 'Optima Business аркылуу жөнөтүү',
    SEND_MYSELF_ACTION: 'Өз алдынча жөнөтүү',
    DOWNLOAD_TITLE: 'Төлөөгө эсепти жүктөө',
    DOWNLOAD: 'Жүктөп алуу',
    BACK_TO_EDIT: 'Редакциялоого кайтуу',
    HINT: 'Төлөм эсебин жөнөтүү Optima24түн колдонуучуларына гана мүмкүн',
    SUCCESS_SEND: 'Эсеп ийгиликтүү жөнөтүлдү',
    SUCCESS_HINT: 'Эсептин статусун «Төлөөгө эсептер» бөлүмүндөгү «Чыгашалар» кошумча бетинен көзөмөлдөсө болот',
    SUCCESS_HINT_CASH: 'Операциянын статусун {salePoint} аркылуу байкап туруңуз',
    PDF_DOWNLOADED_TITLE: 'PDF-эсеп жүктөлдү',
    PDF_DOWNLOADED_HINT:
      'Эсепти төлөөчүгө өзүңүзгө ыңгайлуу болгон каалаган ыкма менен жөнөтүңүз. Төлөмдүн абалын «Чыгыш эсептер» бөлүмүнөн көзөмөлдөй аласыз.',
    PDF_DOWNLOADED_ACTION: 'Эсептерге кайтуу',
    DRAFT_SAVED_TITLE: 'Эсеп караламага сакталды',
    DRAFT_SAVED_HINT: 'Аны «Төлөөгө эсептер» бөлүмүндөгү «Каралама» вкладкасынан таба аласыз',
    TO_INVOICES: 'Эсептерге',
    TO_SIGN: 'Кол коюуга',
    SEND_INVOICE: 'Эсеп чыгаруу',
    REVOKED: 'Эсеп кайтарылып алынды',
    REJECT_QUESTION: 'Төлөөгө эсепти четке кагасызбы?',
    RECALL_QUESTION: 'Төлөөгө эсепти кайтарып аласызбы?',
    REJECT_SUCCESS: 'Эсеп четке кагылды',
    EMPTY_SALE_POINT: 'Төлөмгө эсеп түзүү үчүн, сатуу түйүнүн кошуңуз',
    ASK_SALE_POINT: 'Төлөмгө эсеп түзүү үчүн, жетекчиңизден сатуу түйүнүн кошууну өтүнүңүз',
    STATUS: {
      WAITING: 'Күтүүдө',
      PAID: 'Төлөндү',
      EXPIRED: 'Мөөнөтү өттү',
      CANCELLED_BY_SENDER: 'Кайтарылып алынды',
      REJECTED_BY_PAYER: 'Жокко чыгарылды',
    },
    RULES: {
      MAX_SUM: 'Төлөмдүн суммасы {sum} сомдон ашпашы керек',
    },
    OUTGOING_STATUS: {
      ALL: 'Баары',
      ISSUED: 'Чыгарылды',
      PAID: 'Төлөндү',

      PARTIALLY_PAID: 'Жарым-жартылай төлөндү',
      REJECTED: 'Четке кагылды',
      CANCELLED: 'Жокко чыгарылды',
      EXPIRED: 'Мөөнөтү өттү',
      DRAFT: 'Каралама',
      TITLE: 'Төлөөгө эсеп',
      LEGAL_ENTITY: 'юридикалык жакка / ЖИ',
      BUYER_NAME: 'Сатып алуучунун аталышы',
      COMMENT: 'Эсеп боюнча комментарий',
    },
    INCOMING_STATUS: {
      ALL: 'Баары',
      ISSUED: 'Чыгарылды',
      PAID: 'Төлөндү',

      PARTIALLY_PAID: 'Жарым-жартылай төлөндү',
      REJECTED: 'Четке кагылды',
      CANCELLED: 'Жокко чыгарылды',
      EXPIRED: 'Мөөнөтү өттү',
      TITLE: 'Төлөөгө эсеп',
      LEGAL_ENTITY: 'юридикалык жакка / ЖИ',
      SELLER_NAME: 'Сатуучунун аталышы',
      COMMENT: 'Эсеп боюнча комментарий',
    },
    OUTGOING_FILTER: {
      BUYER_NAME: 'Сатып алуучунун аталышы',
      SORT_AMOUNT: 'Сумма',
      SORT_AMOUNT_ASC: 'Өсүү тартибинде',
      SORT_AMOUNT_DESC: 'Кемуү тартибинде',
    },
    INCOMING_FILTER: {
      SELLER_NAME: 'Сатуучунун аталышы',
      SORT_AMOUNT: 'Сумма',
      SORT_AMOUNT_ASC: 'Өсүү тартибинде',
      SORT_AMOUNT_DESC: 'Кемуү тартибинде',
    },
    DETAILS: {
      PURPOSE: 'Төлөмдүн максаты/Комментарий',
      OPEN: 'Эсепти ачуу',
      INVOICE_NUMBER: 'Эсептин №',
      EXPIRES_AT: 'Эсептин жарактуулук мөөнөтү',
      CREATED_BY: 'Түзүлгөн',
      INVOICE_TYPE: 'Төлөөчүнүн түрү',
      INVOICE_TYPE_INTERNAL: 'Банк ичинде',
      INVOICE_TYPE_EXTERNAL: 'Банктар аралык',
      BUYER_TITLE: 'Контрагент',
      BUYER_LABEL: 'ИНН/Аталышы',
      PRODUCTS: 'Товарлар/кызматтар',
    },
  },
  USER_APPROVE: {
    APPROVE_ACCOUNT: 'Банктын кеңсесинен аккаунтуңузду ырастап, бардык мүмкүнчүлүктөрдү ачыңыз',
    APPROVE_ACCOUNT_SHORT: 'Аккаунтту ырастаңыз',
    APPROVE_ACCOUNT_FOR_OPERATIONS:
      'Банктын кеңсесинен аккаунтуңузду ырастап, операцияларга толук жеткиликтүүлүк алыңыз',
    ACCOUNT_NOT_APPROVE: 'Аккаунт ырасталган жок',
    CREDIT: {
      TITLE: 'Насыялар жана бөлүп төлөөлөр',
      DESCRIPTION: 'Насыя өнүмдөрүн жана бөлүп төлөө кызматтарын кошуңуз',
    },
    TRANSFER: {
      TITLE: 'Башка банкка которуулар',
      DESCRIPTION: 'Өнөктөштөргө төлөмдөрдү чектөөсүз которуу мүмкүн',
    },
    LIMITS: {
      TITLE: 'Кеңейтилген лимиттер',
      DESCRIPTION: 'Чоң операцияларды суммадан чектөө жок жүргүзө аласыз*',
    },
    LIMIT_TRANSFER: {
      TITLE: '* Банкаралык которуулар үчүн лимиттер:',
      ONE_OPERATION: '• Бир операцияга — 200 000 сомго чейин',
      MONTH_OPERATION: '• Айына — 400 000 сомго чейин',
    },
  },
  BANK_OFFICES: {
    TITLE: 'Филиалдар картасы',
    SEARCH_PLACEHOLDER: 'Филиалдын дарегин киргизиңиз',
    EMPTY: 'Филиалдар табылган жок',
  },
  REQUISITES: {
    TITLE: 'Реквизиттер',
    COMPANY_NAME: 'Компаниянын аталышы',
    LEGAL_ADDRESS: 'Юридикалык дареги',
    INTERMEDIARY_BANK: 'ОРТОМЧУ БАНК',
    SWIFT: 'SWIFT',
    INN: 'СТИН',
    STIN: 'СТИН',
    TIN: 'TIN',
    CORRESPONDENT_ACCOUNT: 'Корреспонденттик эсеп',
    IBAN: 'IBAN',
    IKK: 'ИКК',
    BIN: 'БИН',
    CNAPS: 'CNAPS коду',
    ACCOUNT_NO: 'Эсеп номери',
    LOCAL_BIC: 'Жергиликтүү банк идентификатору',
    SWIFT_BIC: 'Эл аралык Swift/BIK банктын коду',
    ROUTING_NUMBER: 'Routing number (ABA)',
    KBE: 'Казакстанда төлөмдөрдө колдонулуучу бюджеттик бирдиктин коду',
    INFO: 'Кошумча маалымат',
    BENEFICIARY_BANK: 'Алуучу банк',
    PURPOSE: 'Төлөмдүн максаты (140 белгиден ашпоо керек)',
    PDF: 'PDFке экспорттоо',
    COPY: 'Реквизиттерди көчүрүү',
    INFO_ACCOUNT: 'Счет боюнча маалымат',
    HISTORY: 'Тарыхы',
  },
};
